<template>
  <div class="flex flex-column align-items-center">
    <SuccessAndFail
      :msjEnable.sync="msjEnable"
      :mensajeDialog="mensaje"
      :buttomAceptar="buttomAceptar"
      :buttomCancelar="buttomCancelar"
      :icon.sync="iconModal"
      @Aceptar="ClickAceptar"
      :aceptar="aceptarLabel"
      :cancelar="cancelarLabel"
    />
    <CustomModal
      ref="modalFinalizacionErrorRef"
      :modalType="modalTypeFinalizacion"
      :title="modalTitleFinalizacion"
      :message="mensajeFinalizacion"
      :showFooter="msjFinalizacionEnable"
      :buttonLabels="['Aceptar']"
      :showSecondaryButton="false"
      @confirm="ClickAceptarFinalizacion"
      @cancel="closeModalFinalizacion"
    />
    <!-- Main -->
    <div v-if="(!datosCargados || isLoadingData) && !isLeaveModalOpen" class="overlay-cargando">
      <ProgressSpinner style="width: 60px; height: 60px" strokeWidth="5" />
    </div>
    <div v-else style="width: 95% !important">
      <HeaderDenunciaGral
        :title="headerTitle"
        :stateText="sumario.sumarioEstado"
        :stateColor="defineStateColor(sumario.sumarioEstado)"
        :isShared="isShared"
        :sumario="sumario"
        :user="user"
      />
      <div class="w-12 bg-white mainCard py-1 px-3 mt-2">
        <TabView
          class="w-full card"
          :key="resumen?.formType"
          @tab-change="onTabChange"
          :activeIndex="tabIndex"
          ref="legalDataTab"
        >
          <TabPanel header="Datos Legales">
            <div class="w-full flex justify-content-between align-items-center pb-3">
              <h2 class="primaryFont tabTitle">Datos Legales</h2>
              <div class="flex gap-3">
                <Button
                  class="button primaryButton"
                  v-if="legalDataStore.isView"
                  :disabled="legalDataStore.isLoading"
                  @click="
                    () => {
                      blockNavigationToAnotherTab();
                      legalDataStore.startEdit();
                    }
                  "
                >
                  <div class="flex align-items-center gap-2 justify-content-center w-full">
                    <Pencil style="width: 20px; height: 20px" />
                    <span>Editar</span>
                  </div>
                </Button>
                <SplitButton
                  v-if="getItems().length && legalDataStore.isView"
                  label="Acciones"
                  :model="getItems()"
                />
                <Button
                  class="secondaryButton button"
                  v-if="legalDataStore.isEdit"
                  :disabled="legalDataStore.isLoading"
                  @click="showCancelModalLegalData"
                >
                  <div class="flex align-items-center gap-2 justify-content-center">
                    <X style="width: 20px; height: 20px" />
                    <span>Cancelar</span>
                  </div>
                </Button>
                <Button
                  class="button primaryButton"
                  v-if="legalDataStore.isEdit"
                  @click="saveLegalDataButtonAction"
                  :disabled="legalDataStore.isLoading || !legalDataStore.isFormValid"
                >
                  <div
                    v-if="!legalDataStore.isLoading"
                    class="flex align-items-center gap-2 justify-content-center"
                  >
                    <Check style="width: 20px; height: 20px" />
                    <span>Guardar</span>
                  </div>
                  <div v-else class="flex align-items-center gap-2 justify-content-center">
                    <i class="pi pi-spin pi-spinner mr-2" style="font-size: 1rem"> </i>
                    <span>Guardando...</span>
                  </div>
                </Button>
              </div>
            </div>
            <div style="position: relative; width: 100%; padding: 0 30px">
              <div v-if="loading" class="w-full flex justify-content-between">
                <ProgressSpinner
                  style="width: 50px; height: 50px"
                  strokeWidth="6"
                  fill="var(--surface-ground)"
                  animationDuration=".5s"
                  class="mb-5"
                />
              </div>
              <div v-if="!loading" class="flex flex-column w-full">
                <DatosLegalesTab />
              </div>
            </div>
          </TabPanel>
          <TabPanel header="Gestión de diligencias y archivos">
            <div class="w-full flex justify-content-between align-items-center pb-3">
              <h2 class="primaryFont tabTitle">Gestión de diligencias y archivos</h2>
              <SplitButton v-if="getItems().length" label="Acciones" :model="getItems()" />
            </div>
            <div class="table-diligence md:col-12" style="background-color: rgba(248, 249, 250, 1)">
              <DataTable
                ref="doubleEllipsisIcon"
                :value="filesAndDiligences"
                :loading="loading"
                test-id="diligenciasTable"
                @row-reorder="onRowReorder"
                responsiveLayout="scroll"
              >
                <div id="double-ellipsis-icon-id">
                  <Column
                    :rowReorder="orderBy.nombre !== 'Fecha' && !sumario.spinnerOrderTablePrintFrom"
                    headerStyle="width: 3rem"
                    :reorderableColumn="false"
                    rowReorderIcon="double-ellipsis-icon"
                  />
                </div>
                <template #header>
                  <div class="table-header flex justify-content-between align-items-center">
                    <div style="margin-top: -25px">
                      <p style="margin-left: 7px">Ordenar Por:</p>
                      <Dropdown
                        test-id="orderByDropDown"
                        style="margin-top: 1px"
                        class="input-order lg:col-5 md:col-7 sm:col-12"
                        v-model="orderBy"
                        :options="orderList"
                        optionLabel="nombre"
                        placeholder="Orden"
                      />
                    </div>
                    <div test-id="saveOrderButton">
                      <Button
                        type="button"
                        v-if="orderBy.nombre === 'Impresión'"
                        class="p-button-success mr-2 mt-buttons"
                        @click="updateOrderTableDataBase"
                        :disabled="sumario.spinnerOrderTablePrintFrom"
                        >{{
                          !sumario.spinnerOrderTablePrintFrom
                            ? "Guardar orden de impresión"
                            : "Guardando..."
                        }}</Button
                      >
                    </div>
                    <div test-id="addDiligenceButton">
                      <Button
                        test-id="buttomAgregarDiligencia"
                        v-if="
                          (isOnlineActuacion() || !$offline.onlineMode) &&
                          sumario.sumarioEstado != 'Finalizada' &&
                          user?.userdata?.claseDeUsuario != 'UsuarioJuzgado'
                        "
                        @click="goToAgregarDiligencia"
                        class="primaryButton button"
                        label="Agregar diligencia"
                      />
                    </div>
                  </div>
                </template>
                <template #empty> Aún no contruyes diligencias. </template>
                <template #loading> Cargando datos. </template>
                <Column field="doc.tipo" header="Tipo">
                  <template #body="slotProps">
                    {{ slotProps.data.Nombre }}
                    <div v-if="slotProps.data.file" style="overflow-wrap: break-word">
                      {{ slotProps.data.Filename }}
                    </div>
                  </template>
                </Column>
                <Column field="doc.creado" header="Fecha">
                  <template #body="slotProps">
                    {{ slotProps.data.Fechainivig || fechaCreacion(slotProps.data.FechaCreacion) }}
                  </template>
                </Column>
                <Column field="doc.creado" header="Propietario de la diligencia">
                  <template #body="slotProps">
                    {{ apellidoNombre(slotProps.data.ApellidoP, slotProps.data.NombreP) }}
                  </template>
                </Column>
                <Column field="doc.creado" header="Tipo de Usuario">
                  <template #body="slotProps">
                    {{ slotProps.data.TipoUsuario }}
                  </template>
                </Column>
                <Column field="doc.creado" header="Dependencia">
                  <template #body="{ data }">
                    {{ data.DependenciaLetra || sumario.dependenciaPolicial }}
                  </template>
                </Column>
                <Column
                  headerStyle="width: 5em; text-align: right;"
                  bodyStyle="padding-right:8px; text-align: right; "
                >
                  <template #header> </template>
                  <template
                    #body="slotProps"
                    class="flex flex-column md:flex-row"
                    style="background-color: blue; text-align: right"
                  >
                    <div class="flex-reverse" style="text-align: right; display: flex">
                      <CustomButton
                        v-if="!slotProps.data.file && determineActionButtonsVisibility(slotProps)"
                        icon="pi pi-eye"
                        button-color="primary"
                        tooltipText="Ver esta diligencia"
                        @click="seeDiligencia(slotProps.data.DiligenciaID)"
                      />
                      <Button
                        v-if="
                          determineEmailButtonVisibility(slotProps.data) &&
                          indexEmailButtonDisabled !== slotProps.index
                        "
                        type="button"
                        v-tooltip.left="'Enviar email a la dependencia'"
                        icon="pi pi-envelope"
                        class="mr-2"
                        @click="
                          () => {
                            ((emailBody = 'emailFileHtml'), sendAllMails(slotProps));
                          }
                        "
                      ></Button>
                      <ProgressSpinner
                        v-if="indexEmailButtonDisabled == slotProps.index"
                        style="width: 40px; height: 40px"
                      />
                      <!-- abre archivo -->
                      <a
                        v-if="slotProps.data.file && determineActionButtonsVisibility(slotProps)"
                        :href="viewFile(slotProps.data)"
                        target="_blank"
                      >
                        <CustomButton
                          icon="pi pi-eye"
                          button-color="primary"
                          tooltipText="Ver este archivo"
                        ></CustomButton>
                      </a>
                      <CustomButton
                        v-if="
                          slotProps.data.file &&
                          authorizedUserDiligencia() &&
                          determineActionButtonsVisibility(slotProps)
                        "
                        tooltipText="Eliminar este archivo"
                        button-color="rgba(211, 47, 47, 1)"
                        icon="pi pi-trash"
                        @click="confirmDelete(slotProps.data, 'archivo')"
                        :test-id="'deleteFile' + slotProps.index"
                      ></CustomButton>
                      <!-- editar diligencia -->
                      <CustomButton
                        v-if="
                          !slotProps.data.file &&
                          authorizedUserDiligencia(slotProps.data.UsuarioID) &&
                          sumario.sumarioEstado != 'Finalizada' &&
                          determineActionButtonsVisibility(slotProps)
                        "
                        tooltipText="Editar esta diligencia"
                        button-color="rgba(250, 200, 76, 1)"
                        icon="pi pi-pencil"
                        @click="editDiligencia(slotProps.data.DiligenciaID)"
                        test-id="button-editar-diligencia"
                      ></CustomButton>

                      <!-- eliminar diligencia -->
                      <CustomButton
                        v-if="
                          isOnlineActuacion() &&
                          !slotProps.data.file &&
                          authorizedUserDiligencia(slotProps.data.UsuarioID) &&
                          sumario.sumarioEstado != 'Finalizada' &&
                          determineActionButtonsVisibility(slotProps)
                        "
                        test-id="butonEliminarDiligencia"
                        button-color="rgba(211, 47, 47, 1)"
                        tooltipText="Eliminar esta diligencia"
                        icon="pi pi-trash"
                        @click="confirmDelete(slotProps.data.DiligenciaID, 'diligencia')"
                      />
                    </div>
                  </template>
                </Column>
                <template #footer>
                  <div
                    class="flex flex-column"
                    style="align-items: flex-end; margin-right: 2.5%; gap: 5px"
                  >
                    <div>
                      Total de diligencias: {{ filesAndDiligences ? filesAndDiligences.length : 0 }}
                    </div>
                    <div>Total de archivos: {{ files ? files.length : 0 }}</div>
                  </div>
                </template>
              </DataTable>
              <div class="flex justify-content-end mt-3">
                <Button
                  v-if="isOnlineActuacion() && sumario.sumarioEstado == 'Vencida'"
                  type="button"
                  icon="pi pi-sun"
                  label="Activar Prorroga"
                  class="p-button-secondary mr-3"
                  @click="activarProrroga()"
                />
                <Button
                  test-id="buttonReestablecerInstruccion"
                  type="button"
                  label="Reestablecer Instrucción"
                  v-tooltip.left="'Reestablecer Actuacion'"
                  icon="pi pi-link"
                  class="p-button-warning mr-2"
                  v-if="
                    authorizedUserActuacion(usersAllowedToEdit) &&
                    sumario.sumarioEstado == 'Finalizada'
                  "
                  @click="changeStatusActuacion()"
                  :disabled="disabledModifyStatusActuation"
                ></Button>
              </div>
              <div v-if="isOnlineActuacion() && user?.userdata?.claseDeUsuario != 'UsuarioJuzgado'">
                <div class="file-title">
                  <b>Adjuntar archivo/s</b>
                </div>
                <div>
                  <CustomFileUpload
                    ref="FileUpload"
                    @parentUpdateFiles="(event, clear) => updateFiles(event, clear)"
                    @parentMyUploader="myUploader"
                    @parentRemoveFiles="RemoveFiles"
                    d="userfile[]"
                    invalidFileSizeMessage="{0}: tamaño no válido, el archivo no debe pesar más de {1}."
                    accept=".jpg, .jpeg, .pdf, .png"
                    :auto="true"
                    :customUpload="true"
                    @uploader="updateFiles"
                    :maxFileSize="15000000"
                    :multiple="true"
                    uploadLabel="Adjuntar"
                    chooseLabel="Examinar archivos"
                    class="p-button-sm"
                  >
                  </CustomFileUpload>
                </div>
                <p
                  v-if="err"
                  style="color: #dc3545; margin-top: 20px; font-weight: 550"
                  class="ml-1 negative-mt"
                >
                  {{ this.err }}
                </p>
              </div>
            </div>
          </TabPanel>
          <TabPanel header="Fecha Hora y Ubicación">
            <div class="w-full flex justify-content-between align-items-center pb-3">
              <h2 class="primaryFont tabTitle">Fecha, Hora y Ubicación</h2>
              <div classs="flex flex-row gap-3">
                <Button
                  class="button primaryButton mr-3"
                  test-id="buttonSaveUbicacion"
                  @click="
                    () => {
                      (blockNavigationToAnotherTab(), (viewMode = false), (editMode = true));
                    }
                  "
                  v-if="viewMode"
                >
                  <div class="flex align-items-center gap-2 justify-content-center w-full">
                    <Pencil style="width: 20px; height: 20px" />
                    <span>Editar</span>
                  </div>
                </Button>
                <Button
                  class="secondaryButton button mr-3"
                  label="Cancelar"
                  icon="pi pi-times"
                  test-id="buttonSaveUbicacion"
                  @click="cancelDateButtonAction()"
                  v-if="!viewMode"
                  :disabled="saveLoading"
                />
                <Button
                  class="button primaryButton"
                  label="Guardar"
                  :icon="saveLoading ? 'pi pi-spin pi-spinner' : 'pi pi-check'"
                  test-id="buttonSaveUbicacion"
                  @click="saveDateButtonAction()"
                  :disabled="saveLoading || buttonDateDisable"
                  v-if="!viewMode"
                />
                <SplitButton
                  v-if="getItems().length && viewMode"
                  label="Acciones"
                  :model="getItems()"
                  class="p-button-raised"
                />
              </div>
            </div>
            <div class="page">
              <div class="content">
                <div style="position: relative; width: 100%; padding: 0 0 0 30px">
                  <div v-if="loading" class="w-full flex justify-content-between">
                    <ProgressSpinner
                      style="width: 50px; height: 50px"
                      strokeWidth="6"
                      fill="var(--surface-ground)"
                      animationDuration=".5s"
                      class="mb-5"
                    />
                  </div>
                  <div v-if="!loading">
                    <FormLugarMomento
                      modelo="sumario"
                      @save="onSave"
                      @retry="closeErrorModal"
                      @cancelSave="cancelContinueButtonAction"
                      @disableSaveButton="
                        (value) => {
                          buttonDateDisable = value;
                        }
                      "
                      :formType="this.formType"
                      :hideSaveAndBackInternalButtons="true"
                      ref="FechaUbiRef"
                      :editMode="editMode"
                      :calledFromviewMode="true"
                      :viewMode="viewMode"
                    />
                  </div>
                </div>
              </div>
            </div>
          </TabPanel>
          <TabPanel header="Afectados">
            <div class="w-full flex justify-content-between align-items-center pb-3">
              <h2 class="primaryFont tabTitle">Afectados</h2>
              <div class="flex gap-3">
                <CustomTooltip
                  v-if="affectedStore.affectedList.length <= 1"
                  :text="'No es posible eliminar este afectado. La actuación debe tener al menos un afectado.'"
                  placement="top"
                >
                  <div>
                    <Button class="deleteButton" :disabled="true">
                      <Trash style="width: 20px; height: 20px" />
                    </Button>
                  </div>
                </CustomTooltip>

                <Button
                  v-else-if="affectedStore.isView && affectedStore.selectedId"
                  class="deleteButton"
                  @click="
                    () => {
                      blockNavigationToAnotherTab();
                      showDeleteAffected();
                    }
                  "
                  :disabled="affectedStore.isLoading"
                >
                  <Trash style="width: 20px; height: 20px" />
                </Button>
                <Button
                  class="button primaryButton"
                  v-if="affectedStore.isView && affectedStore.selectedId"
                  :disabled="
                    affectedStore.isLoading || affectedStore.selected?.Apellido === 'Orden público'
                  "
                  @click="
                    () => {
                      blockNavigationToAnotherTab();
                      affectedStore.startEdit();
                    }
                  "
                >
                  <div class="flex align-items-center gap-2 justify-content-center w-full">
                    <Pencil style="width: 20px; height: 20px" />
                    <span>Editar</span>
                  </div>
                </Button>
                <SplitButton
                  v-if="getItems().length && affectedStore.isView"
                  label="Acciones"
                  :model="getItems()"
                />
                <Button
                  class="secondaryButton button"
                  v-if="affectedStore.isEdit || affectedStore.isCreate"
                  :disabled="affectedStore.isLoading"
                  @click="showCancelModalAffected"
                >
                  <div class="flex align-items-center gap-2 justify-content-center">
                    <X style="width: 20px; height: 20px" />
                    <span>Cancelar</span>
                  </div>
                </Button>
                <Button
                  class="button primaryButton"
                  v-if="affectedStore.isEdit || affectedStore.isCreate"
                  @click="saveAffectedButtonAction"
                  :disabled="affectedStore.isLoading || !affectedStore.isFormValid"
                >
                  <div
                    v-if="!affectedStore.isLoading"
                    class="flex align-items-center gap-2 justify-content-center"
                  >
                    <Check style="width: 20px; height: 20px" />
                    <span>Guardar</span>
                  </div>
                  <div v-else class="flex align-items-center gap-2 justify-content-center">
                    <i class="pi pi-spin pi-spinner mr-2" style="font-size: 1rem"> </i>
                    <span>Guardando...</span>
                  </div>
                </Button>
              </div>
            </div>
            <div style="position: relative; width: 100%; padding: 0 30px">
              <div v-if="loading" class="w-full flex justify-content-between">
                <ProgressSpinner
                  style="width: 50px; height: 50px"
                  strokeWidth="6"
                  fill="var(--surface-ground)"
                  animationDuration=".5s"
                  class="mb-5"
                />
              </div>
              <div v-if="!loading" style="min-height: 100px">
                <AffectedForm
                  :blockNavigationToAnotherTab="blockNavigationToAnotherTab"
                  :removeTheBlockNavigationToAnotherTab="removeTheBlockNavigationToAnotherTab"
                  ref="affectedForm"
                />
              </div>
            </div>
          </TabPanel>
          <TabPanel header="Vinculados" v-if="determineVisibility('vinculateds', currentActuation)">
            <div class="w-full flex justify-content-between align-items-center pb-3">
              <h2 class="primaryFont tabTitle">Vinculados</h2>
              <div class="flex gap-3">
                <Button
                  class="deleteButton"
                  v-if="vinculatedStore.isView && vinculatedStore.selectedId"
                  @click="
                    () => {
                      blockNavigationToAnotherTab();
                      showDeleteVinculated();
                    }
                  "
                  :disabled="vinculatedStore.isLoading"
                >
                  <div>
                    <Trash style="width: 20px; height: 20px" />
                  </div>
                </Button>
                <Button
                  class="button primaryButton"
                  v-if="vinculatedStore.isView && vinculatedStore.selectedId"
                  :disabled="vinculatedStore.isLoading"
                  @click="
                    () => {
                      blockNavigationToAnotherTab();
                      vinculatedStore.startEdit();
                    }
                  "
                >
                  <div class="flex align-items-center gap-2 justify-content-center w-full">
                    <Pencil style="width: 20px; height: 20px" />
                    <span>Editar</span>
                  </div>
                </Button>
                <SplitButton
                  v-if="getItems().length && vinculatedStore.isView"
                  label="Acciones"
                  :model="getItems()"
                />
                <Button
                  class="secondaryButton button"
                  v-if="vinculatedStore.isEdit || vinculatedStore.isCreate"
                  :disabled="vinculatedStore.isLoading"
                  @click="showCancelModalVinculated"
                >
                  <div class="flex align-items-center gap-2 justify-content-center">
                    <X style="width: 20px; height: 20px" />
                    <span>Cancelar</span>
                  </div>
                </Button>
                <Button
                  class="button primaryButton"
                  v-if="vinculatedStore.isEdit || vinculatedStore.isCreate"
                  @click="saveVinculatedButtonAction"
                  :disabled="vinculatedStore.isLoading || !vinculatedStore.isFormValid"
                >
                  <div
                    v-if="!vinculatedStore.isLoading"
                    class="flex align-items-center gap-2 justify-content-center"
                  >
                    <Check style="width: 20px; height: 20px" />
                    <span>Guardar</span>
                  </div>
                  <div v-else class="flex align-items-center gap-2 justify-content-center">
                    <i class="pi pi-spin pi-spinner mr-2" style="font-size: 1rem"> </i>
                    <span>Guardando...</span>
                  </div>
                </Button>
              </div>
            </div>
            <div style="position: relative; width: 100%; padding: 0">
              <div v-if="loading" class="w-full flex justify-content-between">
                <ProgressSpinner
                  style="width: 50px; height: 50px"
                  strokeWidth="6"
                  fill="var(--surface-ground)"
                  animationDuration=".5s"
                  class="mb-5"
                />
              </div>
              <div v-if="!loading" style="min-height: 100px">
                <VinculatedsFormTab
                  :blockNavigationToAnotherTab="blockNavigationToAnotherTab"
                  :removeTheBlockNavigationToAnotherTab="removeTheBlockNavigationToAnotherTab"
                  ref="vinculatedsFormTab"
                />
              </div>
            </div>
          </TabPanel>
          <TabPanel header="Efectos">
            <div class="w-full flex justify-content-between align-items-center pb-3">
              <h2 class="primaryFont tabTitle">Efectos</h2>
              <div class="flex gap-3">
                <Button
                  class="deleteButton"
                  v-if="effectStore.isView && effectStore.selectedId"
                  @click="
                    () => {
                      blockNavigationToAnotherTab();
                      showEliminarEfecto();
                    }
                  "
                  :disabled="effectStore.isLoading"
                >
                  <div>
                    <Trash style="width: 20px; height: 20px" />
                  </div>
                </Button>
                <Button
                  class="button primaryButton"
                  v-if="effectStore.isView && effectStore.selectedId"
                  :disabled="effectStore.isLoading"
                  @click="
                    () => {
                      blockNavigationToAnotherTab();
                      effectStore.startEdit();
                    }
                  "
                >
                  <div class="flex align-items-center gap-2 justify-content-center w-full">
                    <Pencil style="width: 20px; height: 20px" />
                    <span>Editar</span>
                  </div>
                </Button>
                <SplitButton
                  v-if="getItems().length && effectStore.isView"
                  label="Acciones"
                  :model="getItems()"
                />
                <Button
                  class="secondaryButton button"
                  v-if="effectStore.isEdit || effectStore.isCreate"
                  :disabled="effectStore.isLoading"
                  @click="showCancelModal"
                >
                  <div class="flex align-items-center gap-2 justify-content-center">
                    <X style="width: 20px; height: 20px" />
                    <span>Cancelar</span>
                  </div>
                </Button>
                <Button
                  class="button primaryButton"
                  v-if="effectStore.isEdit || effectStore.isCreate"
                  @click="saveEffectButtonAction"
                  :disabled="effectStore.isLoading || !effectStore.isFormValid"
                >
                  <div
                    v-if="!effectStore.isLoading"
                    class="flex align-items-center gap-2 justify-content-center"
                  >
                    <Check style="width: 20px; height: 20px" />
                    <span>Guardar</span>
                  </div>
                  <div v-else class="flex align-items-center gap-2 justify-content-center">
                    <i class="pi pi-spin pi-spinner mr-2" style="font-size: 1rem"> </i>
                    <span>Guardando...</span>
                  </div>
                </Button>
              </div>
            </div>
            <div style="position: relative; width: 100%; padding: 0 30px">
              <div v-if="loading" class="w-full flex justify-content-between">
                <ProgressSpinner
                  style="width: 50px; height: 50px"
                  strokeWidth="6"
                  fill="var(--surface-ground)"
                  animationDuration=".5s"
                  class="mb-5"
                />
              </div>
              <div v-if="!loading" style="min-height: 100px">
                <EfectosForm
                  :blockNavigationToAnotherTab="blockNavigationToAnotherTab"
                  :removeTheBlockNavigationToAnotherTab="removeTheBlockNavigationToAnotherTab"
                />
              </div>
            </div>
          </TabPanel>
          <TabPanel
            header="Personal interviniente"
            v-if="determineVisibility('interveningPersonnel', currentActuation)"
          >
            <div class="w-full flex justify-content-between align-items-center pb-3">
              <h2 class="primaryFont tabTitle">Personal interviniente</h2>
              <div class="flex gap-3">
                <CustomTooltip
                  v-if="intervinienteStore.intervinientesList.length <= 1"
                  :text="'No es posible eliminar este interviniente. La actuación debe tener al menos un interviniente.'"
                  placement="top"
                >
                  <div>
                    <Button class="deleteButton" :disabled="true">
                      <Trash style="width: 20px; height: 20px" />
                    </Button>
                  </div>
                </CustomTooltip>

                <Button
                  v-else-if="intervinienteStore.isView && intervinienteStore.selectedId"
                  class="deleteButton"
                  @click="
                    () => {
                      blockNavigationToAnotherTab();
                      showDeleteInterviniente();
                    }
                  "
                  :disabled="intervinienteStore.isLoading"
                >
                  <Trash style="width: 20px; height: 20px" />
                </Button>
                <Button
                  class="button primaryButton"
                  v-if="intervinienteStore.isView && intervinienteStore.selectedId"
                  :disabled="intervinienteStore.isLoading"
                  @click="
                    () => {
                      blockNavigationToAnotherTab();
                      intervinienteStore.startEdit();
                    }
                  "
                >
                  <div class="flex align-items-center gap-2 justify-content-center w-full">
                    <Pencil style="width: 20px; height: 20px" />
                    <span>Editar</span>
                  </div>
                </Button>
                <SplitButton
                  v-if="getItems().length && intervinienteStore.isView"
                  label="Acciones"
                  :model="getItems()"
                />
                <Button
                  class="secondaryButton button"
                  v-if="intervinienteStore.isEdit || intervinienteStore.isCreate"
                  :disabled="intervinienteStore.isLoading"
                  @click="showCancelModalInterviniente"
                >
                  <div class="flex align-items-center gap-2 justify-content-center">
                    <X style="width: 20px; height: 20px" />
                    <span>Cancelar</span>
                  </div>
                </Button>
                <Button
                  class="button primaryButton"
                  v-if="intervinienteStore.isEdit || intervinienteStore.isCreate"
                  @click="saveIntervinienteButtonAction"
                  :disabled="intervinienteStore.isLoading || !intervinienteStore.isFormValid"
                >
                  <div
                    v-if="!intervinienteStore.isLoading"
                    class="flex align-items-center gap-2 justify-content-center"
                  >
                    <Check style="width: 20px; height: 20px" />
                    <span>Guardar</span>
                  </div>
                  <div v-else class="flex align-items-center gap-2 justify-content-center">
                    <i class="pi pi-spin pi-spinner mr-2" style="font-size: 1rem"> </i>
                    <span>Guardando...</span>
                  </div>
                </Button>
              </div>
            </div>
            <div style="position: relative; width: 100%; padding: 0 30px">
              <div v-if="loading" class="w-full flex justify-content-between">
                <ProgressSpinner
                  style="width: 50px; height: 50px"
                  strokeWidth="6"
                  fill="var(--surface-ground)"
                  animationDuration=".5s"
                  class="mb-5"
                />
              </div>
              <div v-if="!loading" style="min-height: 100px">
                <IntervinienteForm
                  :blockNavigationToAnotherTab="blockNavigationToAnotherTab"
                  :removeTheBlockNavigationToAnotherTab="removeTheBlockNavigationToAnotherTab"
                />
              </div>
            </div>
          </TabPanel>
          <TabPanel header="Evidencias">
            <div class="w-full flex justify-content-between align-items-center pb-3">
              <h2 class="primaryFont tabTitle">Evidencias</h2>
              <div class="flex gap-3">
                <Button
                  v-if="isForensicOrCriminology && evidenciaStore.evidenciasList.length > 0"
                  class="deleteButton"
                  :disabled="evidenciaStore.isLoading"
                  @click="
                    () => {
                      if (evidenciaStore.evidenciasList.length > 0) {
                        evidenciaStore.startDelete();
                      }
                    }
                  "
                >
                  <div>
                    <Trash style="width: 20px; height: 20px" />
                  </div>
                </Button>
                <Button
                  v-if="isForensicOrCriminology && evidenciaStore.evidenciasList.length > 0"
                  class="button primaryButton"
                  :disabled="evidenciaStore.isLoading"
                  @click="
                    () => {
                      if (evidenciaStore.evidenciasList.length > 0) {
                        const evidencia = evidenciaStore.evidenciasList[0];
                        evidenciaStore.startEdit(evidencia.Url);
                      }
                    }
                  "
                >
                  <div class="flex align-items-center gap-2 justify-content-center w-full">
                    <Pencil style="width: 20px; height: 20px" />
                    <span>Editar</span>
                  </div>
                </Button>
                <SplitButton v-if="getItems().length" label="Acciones" :model="getItems()" />
              </div>
            </div>
            <div style="position: relative; width: 100%; padding: 0 30px">
              <div v-if="loading" class="w-full flex justify-content-between">
                <ProgressSpinner
                  style="width: 50px; height: 50px"
                  strokeWidth="6"
                  fill="var(--surface-ground)"
                  animationDuration=".5s"
                  class="mb-5"
                />
              </div>
              <div v-if="!loading" style="min-height: 100px">
                <EvidenciasTab :key="evidenciasTabKey" />
              </div>
            </div>
          </TabPanel>
          <TabPanel
            header="Afectación Patrimonial"
            v-if="determineVisibility('patrimonialAffectation', currentActuation)"
          >
            <div class="w-full flex justify-content-between align-items-center pb-3">
              <h2 class="primaryFont tabTitle">Afectación Patrimonial</h2>
              <SplitButton v-if="getItems().length" label="Acciones" :model="getItems()" />
            </div>
            <AfectacionTab v-if="renderAfectation" />
          </TabPanel>
        </TabView>
      </div>
    </div>
    <CustomModal
      title="Cancelar carga de datos"
      modalType="warning"
      message="Si cancelas ahora, la información ingresada se perderá y no podrá recuperarse. ¿Deseas continuar con la cancelación?"
      :button-labels="['Aceptar', 'Cancelar']"
      @confirm="confirmLeave"
      @cancel="cancelLeave"
      ref="ModalRefLeave"
    />
    <CustomModal
      title="Confirmación de Eliminación"
      modalType="delete"
      :message="modalRefMessage"
      :button-labels="['Eliminar', 'Cancelar']"
      @confirm="deleteConfirmed"
      @cancel="cancelDelete"
      ref="ModalRefDelete"
    />
    <CustomModal
      title="¿Desea finalizar la instrucción?"
      modalType="warning"
      message="Esta acción es definitiva y no podrá revertirse. Para confirmar, haga clic en Finalizar. Si desea revisar nuevamente, haga clic en Cancelar."
      :button-labels="['Finalizar', 'Cancelar']"
      @confirm="openModalEsclarecido()"
      @cancel="closeModalTemplate(ModalRefConfirm)"
      ref="ModalRefConfirm"
    />
    <CustomModal
      title="¿El hecho fue esclarecido?"
      message="Antes de finalizar la actuación, indique si el hecho fue esclarecido seleccionando la opción correspondiente. Si es necesario, puede brindar más detalles en la descripción."
      ref="ModalRefEsclarecido"
      modalType="info"
      :requireAction="true"
      :button-labels="['Confirmar', 'Cancelar']"
      @confirm="handleFinalizarActuacion"
      @cancel="$refs.ModalRefEsclarecido.close()"
    >
      <template #action="{ setValid }">
        <div class="flex flex-column gap-3 mb-2">
          <div class="flex flex-column gap-2">
            <div class="flex align-items-center gap-2">
              <RadioButton
                inputId="esclarecidoSi"
                name="esclarecido"
                :value="true"
                v-model="isEsclarecido"
                @change="setValid(isEsclarecido !== null && !errorDescripcion)"
              />
              <label for="esclarecidoSi">Sí</label>
            </div>
            <div class="flex align-items-center gap-2">
              <RadioButton
                inputId="esclarecidoNo"
                name="esclarecido"
                :value="false"
                v-model="isEsclarecido"
                @change="setValid(isEsclarecido !== null && !errorDescripcion)"
              />
              <label for="esclarecidoNo">No</label>
            </div>
          </div>

          <Textarea
            v-model="DescripcionFinalizacion"
            placeholder="Ingrese descripción."
            autoResize
            rows="3"
            class="w-full"
            maxlength="200"
            @input="setValid(isEsclarecido !== null && !errorDescripcion)"
          />
          <span class="w-full text-red-500 text-left" v-if="errorDescripcion">{{
            errorDescripcion
          }}</span>
        </div>
      </template>
    </CustomModal>
    <CustomModal
      title="Información"
      modalType="info"
      :showSecondaryButton="false"
      :button-labels="['Aceptar']"
      message="Debe cargar al menos 3 diligencias para finalizar la actuación"
      @confirm="closeModalTemplate(ModalRefInform)"
      ref="ModalRefInform"
    />
    <CustomModal
      title="Eliminar actuación"
      modalType="delete"
      message="¿Está seguro de que desea eliminar esta actuación? Esta acción es permanente y no se podrá deshacer."
      :button-labels="['Eliminar', 'Cancelar']"
      @confirm="deleteConfirmed(true)"
      @cancel="closeModalTemplate(ModalConfirmDeleteActuacion)"
      ref="ModalConfirmDeleteActuacion"
    />
    <CustomModal
      title="Enviar a otra dependencia"
      modalType="warning"
      message="Seleccione la dependencia a la que desea enviar la actuación. Una vez enviada, la misma no podrá ser modificada."
      :requireAction="true"
      :showSecondaryButton="false"
      :closable="true"
      :loading="isDisabled.btnEnviar"
      :button-labels="['Enviar definitivamente']"
      appendTo="body"
      @confirm="btnEnvio"
      ref="ModalRefSendDependency"
    >
      <template #action="{ setValid, appendTo }">
        <AutoComplete
          v-model="dataDependencia"
          :suggestions="filteredDependencia"
          @complete="filterDependencia($event)"
          :dropdown="true"
          field="dependencia"
          placeholder="Dependencia"
          :appendTo="appendTo"
          @input="setValid(!!dataDependencia)"
          class="w-full text-left input"
        />
      </template>
    </CustomModal>
    <CustomModal
      title="Cambiar tipo de actuación"
      modalType="info"
      message="Seleccione el nuevo tipo de actuación"
      :button-labels="['Confirmar', 'Cancelar']"
      :requireAction="true"
      ref="ModalRefSwitchActuacion"
      @cancel="ModalRefSwitchActuacion.close()"
      :loading="isConfirmDisabled"
      @confirm="switchActuacion()"
      appendTo="body"
    >
      <template #action="{ setValid, appendTo }">
        <Dropdown
          :options="filteredOptions"
          optionLabel="label"
          optionValue="value"
          placeholder="Seleccione tipo de actuación"
          v-model="actuacionIDforChange"
          :appendTo="appendTo"
          @change="setValid(actuacionIDforChange !== null)"
          class="w-full text-left input"
        />
      </template>
    </CustomModal>
    <CustomModal
      title="Compartir actuación con otra dependencia"
      message="Ambas dependencias podrán trabajar sobre la actuación, pero el control permanecerá en su dependencia de origen."
      modalType="warning"
      :button-labels="['Campartir', 'Cancelar']"
      @confirm="handleShareActuacion(true)"
      :loading="loadingShare"
      @cancel="closeModalTemplate(ModalShareConfirm)"
      ref="ModalShareConfirm"
    />
    <CustomModal
      title="¿Está seguro de que desea compartir esta actuación?"
      message="Seleccione la dependencia con la que desea compartir esta actuación. Ambas dependencias podrán visualizar, gestionar diligencias y consultar archivos asociados, trabajando de manera conjunta."
      modalType="warning"
      :requireAction="true"
      :button-labels="['Aceptar', 'Cancelar']"
      @confirm="handleShareActuacion()"
      @cancel="closeModalTemplate(ModalRefShare)"
      appendTo="body"
      ref="ModalRefShare"
    >
      <template #action="{ setValid, appendTo }">
        <div class="flex w-full mb-3">
          <Dropdown
            :options="dependenciasFiltradas"
            optionLabel="label"
            optionValue="value"
            placeholder="Seleccione Dependencia"
            v-model="dependenciaForShare"
            :appendTo="appendTo"
            class="w-full text-left input"
            @change="setValid(dependenciaForShare !== null)"
          />
        </div>
      </template>
    </CustomModal>
    <CustomModal
      ref="effectModalRef"
      :title="effectModalData.title"
      :message="effectModalData.message"
      :modalType="effectModalData.modalType"
      :showSecondaryButton="effectModalData.showSecondaryButton"
      :button-labels="effectModalData.buttonLabels"
      @confirm="effectModalData.onConfirm"
      @cancel="effectModalData.onCancel"
      :loading="effectStore.isLoading"
    />
    <CustomModal
      ref="affectedModalRef"
      :title="affectedModalData.title"
      :message="affectedModalData.message"
      :modalType="affectedModalData.modalType"
      :showSecondaryButton="affectedModalData.showSecondaryButton"
      :button-labels="affectedModalData.buttonLabels"
      @confirm="affectedModalData.onConfirm"
      @cancel="affectedModalData.onCancel"
      :loading="affectedStore.isLoading"
    >
      <template v-slot:primaryButton="{ loading, buttonLabels, onConfirm }">
        <button :disabled="loading" @click="onConfirm">
          {{ buttonLabels[0] }}
          <span v-if="loading" class="spinner"></span>
        </button>
      </template>
    </CustomModal>
    <CustomModal
      ref="legalDataModalRef"
      :title="legalDataModalData.title"
      :message="legalDataModalData.message"
      :modalType="legalDataModalData.modalType"
      :showSecondaryButton="legalDataModalData.showSecondaryButton"
      :button-labels="legalDataModalData.buttonLabels"
      @confirm="legalDataModalData.onConfirm"
      @cancel="legalDataModalData.onCancel"
      :loading="legalDataStore.isLoading"
    />
    <CustomModal
      ref="vinculatedModalRef"
      :title="vinculatedModalData.title"
      :message="vinculatedModalData.message"
      :modalType="vinculatedModalData.modalType"
      :showSecondaryButton="vinculatedModalData.showSecondaryButton"
      :button-labels="vinculatedModalData.buttonLabels"
      @confirm="vinculatedModalData.onConfirm"
      @cancel="vinculatedModalData.onCancel"
      :loading="vinculatedStore.isLoading"
    >
      <template v-slot:primaryButton="{ loading, buttonLabels, onConfirm }">
        <button :disabled="loading" @click="onConfirm">
          {{ buttonLabels[0] }}
          <span v-if="loading" class="spinner"></span>
        </button>
      </template>
    </CustomModal>
    <CustomModal
      ref="intervinienteModalRef"
      :title="intervinienteModalData.title"
      :message="intervinienteModalData.message"
      :modalType="intervinienteModalData.modalType"
      :showSecondaryButton="intervinienteModalData.showSecondaryButton"
      :button-labels="intervinienteModalData.buttonLabels"
      @confirm="intervinienteModalData.onConfirm"
      @cancel="intervinienteModalData.onCancel"
      :loading="intervinienteStore.isLoading"
    >
      <template v-slot:primaryButton="{ loading, buttonLabels, onConfirm }">
        <button :disabled="loading" @click="onConfirm">
          {{ buttonLabels[0] }}
          <span v-if="loading" class="spinner"></span>
        </button>
      </template>
    </CustomModal>
    <ModalTemplate
      title="¿Estás por salir sin guardar los cambios?"
      :showIcon="false"
      :closable="false"
      ref="modalDateChangesWithoutSave"
    >
      <div class="">
        Si decidís cancelar, toda la información que cargaste hasta ahora se perderá. Podés
        continuar para guardar o volver para revisar antes de salir.
      </div>
      <div class="w-full flex justify-content-end gap-2">
        <Button
          label="Cancelar"
          class="bg-transparent text-gray-900 font-medium border-600 border-round-lg w-5"
          @click="closeModalTemplate(ModalRefShare)"
        />
        <Button
          label="Aceptar"
          class="border-round-lg w-5"
          :disabled="!dependenciaForShare"
          @click="handleShareActuacion()"
        />
      </div>
    </ModalTemplate>
    <ModalTemplate title="" :showIcon="false" :closable="true" ref="modalDateChangesSaved">
      <div
        class="w-full flex flex-column align-items-center justify-content-center text-center gap-4"
        style="min-height: 240px"
      >
        <span
          class="flex align-items-center justify-content-center w-6rem h-6rem border-3 border-round-lg"
          style="color: var(--green-500); border-color: currentColor"
          role="img"
          aria-label="Operación exitosa"
        >
          <i class="pi pi-check text-4xl"></i>
        </span>

        <h3 class="m-0 font-semibold text-xl line-height-3 text-color">
          Los cambios se guardaron correctamente
        </h3>

        <div class="w-8rem h-3 border-round mx-auto" style="background: var(--primary-500)"></div>
      </div>
    </ModalTemplate>
  </div>
</template>

<script>
import CustomFileUpload from "../../components/custom-fileupload";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import axios from "axios";
import ModalTemplate from "../../components/ModalTemplate.vue";
import generalFunctions from "../../store/modules/generalFunctions.js";
import { actuacionesConfig } from "@/router/RoutesConfig/actuacionesConfig/actuacionesConfig";
import "vue-toast-notification/dist/theme-sugar.css";
import Dropdown from "primevue/dropdown/Dropdown";
import PDFViewer from "../../components/PDF-viewer/PDFViewer.vue";
import SplitButton from "primevue/splitbutton";
import CustomButton from "@/components/custom-button/CustomButton.vue";
import DenunciantesView from "./componentsViewActuacion/DenunciantesView.vue";
import RadioButton from "primevue/radiobutton";
import {
  defineComponent,
  getCurrentInstance,
  nextTick,
  onBeforeMount,
  onMounted,
  reactive,
  ref,
  watch,
  computed,
} from "vue";
import { useStoreCompat } from "@/composables/useStoreCompat";
import { useRest } from "@/composables/useRest";
import { useToast } from "@/composables/useToast";
import { useRouterCompat } from "@/composables/useRouterCompat";
import { useOfflineCompat } from "@/composables/useOfflineCompat";
import { useActuations } from "@/composables/useActuaciones";
import { useProsecutor } from "@/composables/DenunciaFormDatosGenerales/useProsecutor";
import {
  EvidenciasTab,
  EfectosForm,
  AfectacionTab,
  AffectedForm,
  VinculatedsFormTab,
  IntervinienteForm,
} from "./componentsViewActuacion/index.js";
import { useDependenciasStore } from "@/store/Pinia/useDependenciasStore";
import { useAfectacionStore } from "@/store/Pinia/useAfectacionStore";
import FormLugarMomento from "@/components/forms/FormLugarMomento.vue";
import HeaderDenunciaGral from "./componentsViewActuacion/HeaderDenunciaGral.vue";
import { Trash, Pencil, X, Check, TriangleAlert } from "lucide-vue";
import { useEffectStore } from "@/store/Pinia/useEffectStore";
import { useAffectedStore } from "@/store/Pinia/useAffectedStore";
import { useVinculatedStore } from "@/store/Pinia/useVinculatedStore";
import { usePersonalIntervinienteStore } from "@/store/Pinia/usePersonalIntervinienteStore";
import { useDatesAndLocationsStore } from "@/store/Pinia/useDatesAndLocationsStore";
import functionsEditMode from "@/store/modules/sumario/editModeModules/functionsEditMode";
import { verifyInternetConnection } from "@/utils/verifyInternetConnection";
import { useTabVisibility } from "@/composables/useTabVisibility";
import CustomTooltip from "@/components/CustomTooltip.vue";
import { useEvidenciaStore } from "@/store/Pinia/useEvidenciaStore";
import { useBreadcrumbStore } from "@/store/Pinia/useBreadcrumbStore";
import DatosLegalesTab from "./componentsViewActuacion/DatosLegalesTab.vue";
import { useJuzgadosStore } from "@/store/Pinia/useJuzgadosStore";
import { useUfisStore } from "@/store/Pinia/useUfisStore";
import { usePersonalFiscalStore } from "@/store/Pinia/usePersonalFiscalStore";
import { useLegalDataStore } from "@/store/Pinia/useLegalDataStore";
import { useModusOperandiStore } from "@/store/Pinia/useModusOperandiStore";
import { useSitioStore } from "@/store/Pinia/useSitioStore";
import { useArticulosStore } from "@/store/Pinia/useArticulosStore";
import { useCausaCaratulaStore } from "@/store/Pinia/useCausaCaratulaStore";
import { useDelitosStore } from "@/store/Pinia/useDelitosStore";
import CustomModal from "@/components/CustomModal.vue";

const { determineVisibility } = useTabVisibility();

export default defineComponent({
  name: "DenunciaFormDatosGenerales",
  components: {
    DataTable,
    Column,
    CustomFileUpload,
    ModalTemplate,
    PDFViewer,
    SplitButton,
    CustomButton,
    DenunciantesView,
    EfectosForm,
    RadioButton,
    EvidenciasTab,
    CustomModal,
    AfectacionTab,
    AffectedForm,
    VinculatedsFormTab,
    IntervinienteForm,
    DatosLegalesTab,
    Trash,
    Pencil,
    X,
    Check,
    FormLugarMomento,
    HeaderDenunciaGral,
    TriangleAlert,
    CustomTooltip,
  },
  setup(props, { emit }) {
    const store = useStoreCompat();
    const rest = useRest();
    const toast = useToast();
    const afectacionStore = useAfectacionStore();
    const evidenciaStore = useEvidenciaStore();
    const breadcrumbStore = useBreadcrumbStore();
    const { router, route } = useRouterCompat();
    const offline = useOfflineCompat();
    const { saveActuationInCache, deleteGenericDataFromCached } = useActuations();

    const dependenciasStore = useDependenciasStore();
    const juzgadosStore = useJuzgadosStore();
    const ufisStore = useUfisStore();
    const personalFiscalStore = usePersonalFiscalStore();
    const legalDataStore = useLegalDataStore();
    const modusOperandiStore = useModusOperandiStore();
    const sitioStore = useSitioStore();
    const articulosStore = useArticulosStore();
    const causaCaratulaStore = useCausaCaratulaStore();
    const delitosStore = useDelitosStore();
    const { prosecutorUserTypes } = useProsecutor();
    const ActuacionID = ref();
    const isLoadingData = ref(false);
    const dependenciaList = computed(() => dependenciasStore.dependencias);
    const resumen = computed(() => store.getters["sumario/dataResumen"]);
    const sumario = computed(() => store.state.sumario);
    const currentActuation = computed(() => sumario.value?.tiposumarioID);
    const user = computed(() => store.state.user);
    const viewData = computed(() => store.state.sumarioViews);
    const formType = computed(() => store.state.sumario.formType);
    const dependencyOwn = computed(() => user.value.userdata.tipoUsuario);
    const denunciante = computed(() => store.state.sumario.denunciante);
    const headerTitle = computed(() => {
      return `${formatNameUFI(resumen.value?.formType)} - ${sumario.value.causaNumero} - ${sumario.value.dependenciaPolicial}`;
    });
    const evidenciasTabKey = ref(0);
    const renderAfectation = ref(false);
    const viewMode = ref(true);
    const editMode = ref(false);
    const modalDateChangesWithoutSave = ref(null);
    const modalDateChangesSaved = ref(null);
    let datesAndLocationsStore = ref(null);
    const loadingShare = ref(false);
    const affectedForm = ref(null);
    const vinculatedsFormTab = ref(null);

    const mostrarPersonalInterviniente = computed(() => {
      const tipoSumario = sumario.value?.formType || sumario.value?.tiposumarioID;
      const tiposPermitidos = [
        "Sumario Prevencional Por Oficio",
        "Expediente Contravencional por oficio",
        "Unidades Fiscales de Investigación Delitos Genéricos por Oficio",
        "Unidades Fiscales de Investigacion ANIVI",
        "Unidades Fiscales de Investigacion Flagrancia",
        "Unidades Fiscales de Investigación Delitos Contra la Propiedad por Oficio",
        "Unidades Fiscales de Investigacion CAVIG",
        "Unidades Fiscales de Investigación Delitos Informáticos y Estafas por Oficio",
        "Unidades Fiscales de Investigacion D.E Emergencias Medicas",
        "Unidades Fiscales de Investigacion D.E Siniestro Vial",
        "Unidades Fiscales de Investigacion D.E Ahorcamiento o Suicidio",
        "Unidades Fiscales de Investigacion D.E Incendio en Vivienda",
        "Unidades Fiscales de Investigacion D.E Intoxicacion",
        "Actuacion Preliminar por Incendio en Vivienda",
        "Actuacion Preliminar para Establecer Procedencias",
        "Actuacion Preliminar por Fuga de Menor",
        "Actuacion Preliminar por Siniestro Vial",
        "Actuacion Preliminar por Caida Casual",
        "Actuacion Preliminar por Incendio de Automotor",
        "Actuacion Preliminar por Tentativa de Suicidio",
        "Actuacion Preliminar - Otros",
      ];
      return tiposPermitidos.includes(tipoSumario);
    });

    const mostrarAfectacionPatrimonial = computed(() => {
      const tipoSumario = sumario.value?.formType || sumario.value?.tiposumarioID;
      const tiposPermitidos = [
        "Unidades Fiscales de Investigación Delitos Informáticos y Estafas por Oficio",
        "Unidades Fiscales de Investigación Delitos Informáticos y Estafas por Denuncia",
      ];
      return tiposPermitidos.includes(tipoSumario);
    });

    const currentDate = computed(() => {
      const current = new Date();
      const options = { year: "numeric", month: "long", day: "numeric", timeZone: "UTC" };
      const parts = current.toLocaleDateString("es-ES", options).split(" de ");
      return `${parts[0]} de ${parts[1]} del ${parts[2]}`;
    });

    const emailFileHtml = computed(() => {
      return `
        <p>${dependencyOwn.value}, ${currentDate.value}</p>
        <h1>${sumario.value.tiposumarioID}</h1>
        <p>S/D</p>
        <p>Objeto: R/ Informe Técnico</p>
        <p>
          Me dirijo a Ud. a fin de informar en relación a lo solicitado por el Sr. Jefe de
          ${resumen.value.dependencia}, en nota OFICIO LEGAJO Nº ${sumario.value.causaNumero}
        </p>
        <p>Dando cumplimiento a lo solicitado.</p>
      `;
    });

    const emailEvidenceHtml = computed(() => {
      return `
        <p>${dependencyOwn.value}, ${currentDate.value}</p>
        <h1>${sumario.value.tiposumarioID}</h1>
        <p>S/D</p>
        <p>Objeto: R/ Informe Técnico</p>
        <p>
          Me dirijo a Ud. a fin de informar en relación a lo solicitado por el Sr. Jefe de
          ${resumen.value.dependencia}, en nota OFICIO LEGAJO Nº ${sumario.value.causaNumero}
        </p>
        <p>
          A continuación podrá acceder a la evidencia: <a href='${proxy.evidence}'> ${proxy.evidence}</a>
        </p>
        <p>Dando cumplimiento a lo solicitado.</p>
      `;
    });

    const translateNameFromFormType = computed(() => generalFunctions.translateNameFromFormType);

    const usersAllowedToEdit = computed(() => {
      let usersAllowed = [
        "Super User",
        "SecretarioActual",
        "Jefe de Sumario",
        "Jefe de Dependencia",
      ];
      usersAllowed = usersAllowed.concat(prosecutorUserTypes);
      return usersAllowed;
    });

    const isForensicOrCriminology = computed(() => {
      const tipo = user.value.userdata.tipoUsuario;
      return (
        tipo === "Dpto.Criminalistica" ||
        tipo === "Lab. Informatico Forense" ||
        tipo === "Super User"
      );
    });

    const filteredOptions = computed(() => {
      const allOptions = [
        { name: "Unidades Fiscales de Investigación Delitos Contra la Propiedad por Denuncia" },
        { name: "Unidades Fiscales de Investigación Delitos Genéricos por Denuncia" },
        { name: "Unidades Fiscales de Investigacion Flagrancia" },
        { name: "Unidades Fiscales de Investigación Delitos Genéricos por Oficio" },
        { name: "Unidades Fiscales de Investigación Delitos Contra la Propiedad por Oficio" },
      ];

      const group = {
        group1: [
          "Unidades Fiscales de Investigación Delitos Contra la Propiedad por Denuncia",
          "Unidades Fiscales de Investigación Delitos Genéricos por Denuncia",
        ],
        group2: [
          "Unidades Fiscales de Investigacion Flagrancia",
          "Unidades Fiscales de Investigación Delitos Genéricos por Oficio",
          "Unidades Fiscales de Investigación Delitos Contra la Propiedad por Oficio",
        ],
      };

      const currentType = resumen.value?.formType || "";

      const allowedOptions =
        Object.values(group)
          .find((group) => group.includes(currentType))
          ?.filter((option) => option !== currentType) || [];

      return allOptions
        .filter((option) => allowedOptions.includes(option.name))
        .map((option) => ({
          label: proxy.formatNameUFI(option.name),
          value: option.name,
        }));
    });

    const dataDependencia = computed({
      get: () => dependencia.value,
      set: (val) => (dependencia.value = val),
    });

    const modalUpdateRef = ref(null);

    const dependenciasFiltradas = computed(() => {
      return dependenciaList.value
        .filter((dep) => dep.dependencia.toLowerCase().includes("brigada"))
        .map((dep) => ({
          label: dep.dependencia,
          value: dep.id,
        }));
    });

    let tabsMap = computed(() => {
      let newTabsMap = [];
      let i = 0;
      const nodes = legalDataTab.value.$refs.content.lastChild.childNodes;
      nodes.forEach((li) => {
        newTabsMap.push({ id: i, name: li.innerText.trim() });
        i++;
      });
      return newTabsMap;
    });

    const fileData = ref(null);
    const itemTypeToDelete = ref(null);
    const modalRefMessage = ref("");
    const indexEmailButtonDisabled = ref(null);
    const disabledModifyStatusActuation = ref(false);
    const iconModal = ref({});
    const buttomAceptar = ref({ buttom: true, action: true });
    const buttomCancelar = ref({ buttom: true, action: false });
    const msjEnable = ref(false);
    const mensaje = ref("");
    const formData = ref(null);
    const err = ref(false);
    const files = ref(null);
    const filesAndDiligences = ref([]);
    const filesAndDiligencesByDate = ref([]);
    const loading = ref(false);
    const dependencia = ref("");
    const filteredDependencia = ref([]);
    const sumarioEstado = ref("");
    const aceptarLabel = ref(undefined);
    const cancelarLabel = ref(undefined);
    const ClickAceptar = ref(() => {});
    const evidence = ref("");
    const emailBody = ref("");
    const actuacionIDforChange = ref("");
    const isConfirmDisabled = ref(false);
    const DescripcionFinalizacion = ref("");
    const errorDescripcion = ref(null);
    const isEsclarecido = ref(null);
    const actuacionType = ref(null);
    const tabIndex = ref(0);
    const customModalRef = ref(null);
    const modalFinalizacionErrorRef = ref(null);
    const msjFinalizacionEnable = ref(false);
    const mensajeFinalizacion = ref("");
    const modalTypeFinalizacion = ref("warning");
    const modalTitleFinalizacion = ref("Error");
    const ClickAceptarFinalizacion = ref(() => {});

    const orderBy = ref({ id: 1, nombre: "Fecha" });
    const isDisabled = reactive({ btnEnviar: false });
    const orderList = ref([
      { id: 1, nombre: "Fecha" },
      { id: 2, nombre: "Impresión" },
    ]);
    const filteredOrder = ref([]);
    const FechaUbiRef = ref(null);
    const FileUpload = ref(null);
    const ModalRefEsclarecido = ref(null);
    const ModalRefConfirm = ref(null);
    const ModalRefInform = ref(null);
    const ModalRefSwitchActuacion = ref(null);
    const ModalRefDelete = ref(null);
    const ModalRefSendDependency = ref(null);
    const ModalRefShare = ref(null);
    const ModalConfirmDeleteActuacion = ref(null);
    const dependenciaForShare = ref(null);
    const ModalShareConfirm = ref(null);
    const isShared = ref(false);
    const saveLoading = ref(false);
    const legalDataTab = ref(false);
    let tabToRedirect = ref(null);
    const buttonDateDisable = ref(false);

    const datosCargados = computed(() => {
      return !!sumario.value?.id && resumen.value?.formulario;
    });

    const permisosPorUsuario = {
      //UserAdmin
      "Usuario Admin": [
        "Editar Actuacion",
        "Cambiar tipo de actuación",
        "Enviar a otra dependencia",
        "Finalizar instrucción",
        "Eliminar Actuacion",
        "Compartir Actuación",
      ],
      "Super User": [
        "Editar Actuacion",
        "Cambiar tipo de actuación",
        "Enviar a otra dependencia",
        "Finalizar instrucción",
        "Eliminar Actuacion",
        "Compartir Actuación",
      ],
      "User Tester": [
        "Editar Actuacion",
        "Cambiar tipo de actuación",
        "Enviar a otra dependencia",
        "Finalizar instrucción",
        "Eliminar Actuacion",
        "Compartir Actuación",
      ],
      //UserDependencia
      "Jefe de Sumario": [
        "Editar Actuacion",
        "Cambiar tipo de actuación",
        "Enviar a otra dependencia",
        "Finalizar instrucción",
        "Eliminar Actuacion",
        "Compartir Actuación",
      ],
      "Jefe de Dependencia": [
        "Editar Actuacion",
        "Cambiar tipo de actuación",
        "Enviar a otra dependencia",
        "Finalizar instrucción",
        "Eliminar Actuacion",
        "Compartir Actuación",
      ],
      //oficial Sumariante
      "Oficial Sumariante": [
        "Editar Actuacion",
        "Cambiar tipo de actuación",
        "Enviar a otra dependencia",
        "Finalizar instrucción",
        "Compartir Actuación",
      ],

      //UserFiscal
      "Fiscal General": ["Editar Actuacion", "Finalizar Actuacion"],
      Supervisor: ["Editar Actuacion", "Finalizar Actuacion"],
      "Ayudante Fiscal": ["Editar Actuacion", "Finalizar Actuacion"],
      UsuarioFiscal: ["Editar Actuacion", "Finalizar Actuacion"],
      Fiscal: ["Editar Actuacion", "Finalizar Actuacion"],
      Administrativo: ["Editar Actuacion", "Finalizar Actuacion"],
      "Policia Investigador": ["Editar Actuacion", "Finalizar Actuacion"],
    };

    const acciones = {
      "Editar Actuacion": {
        label: "Editar Actuacion",
        icon: "pi pi-pencil",
        command: () => {
          editarActuacion();
        },
      },
      "Cambiar tipo de actuación": {
        label: "Cambiar tipo de actuación",
        icon: "pi pi-sync",
        command: () => {
          openModalTemplate(ModalRefSwitchActuacion);
        },
      },
      "Enviar a otra dependencia": {
        label: "Enviar a otra dependencia",
        icon: "pi pi-sign-out",
        command: () => {
          openModalTemplate(ModalRefSendDependency);
        },
      },
      "Finalizar instrucción": {
        label: "Finalizar instrucción",
        icon: "pi pi-times-circle",
        command: () => {
          verifyAmountOfDiligences("ModalRefConfirm");
        },
      },
      "Eliminar Actuacion": {
        label: "Eliminar Actuacion",
        icon: "pi pi-trash",
        command: () => {
          openModalTemplate(ModalConfirmDeleteActuacion);
        },
      },
      "Compartir Actuación": {
        label: "Compartir Actuación",
        icon: "pi pi-link",
        command: () => {
          openModalTemplate(ModalRefShare);
        },
      },
    };

    onBeforeMount(async () => {
      store.dispatch("sumario/resetState");

      let { id } = route.params;
      loading.value = true;
      id = id.includes("toUpdate") ? id.replace("toUpdate", "") : id;
      ActuacionID.value = id;
      handleIsShared(id);
      setTimeout(async () => {
        await store.dispatch("sumario/setSumario", id);
        await store.dispatch("sumario/fetchOriginalUser", sumario.value.id);
        await saveActuationInCache(id, sumario);
        sortByDate();
        loading.value = false;
      }, 100);
      await dependenciasStore.setDependencias();
      store.dispatch("siis/setModusoperandi");
      await store.dispatch("siis/setSitio");
      store.dispatch("siis/setArticulos");
      store.dispatch("siis/setJuzgados");
      store.dispatch("siis/setCausaCaratula");
      store.dispatch("siis/setDelitos");
      store.dispatch("siis/setUFIs");
      store.dispatch("siis/setCausaCaratula");
      store.dispatch("siis/setProsecutorOrAssistant", { en: "prosecutors", es: "fiscal" });
      store.dispatch("siis/setProsecutorOrAssistant", { en: "assistants", es: "ayudante" });
    });

    onMounted(() => {
      datesAndLocationsStore = useDatesAndLocationsStore();
      getDefaultEvidence();

      // Construir la URL de vuelta preservando los filtros (query params)
      const listUrl = route.query?.filtros
        ? `/actuaciones/list?filtros=${route.query.filtros}`
        : "/actuaciones/list";

      breadcrumbStore.setItems([
        { label: "Listado de actuaciones", to: listUrl },
        { label: "Detalle de la Actuación", to: route.fullPath },
      ]);

      const scrollY = parseInt(route.query.scrollY || "0");
      const tabIndexQuery = parseInt(route.query.tabIndex || "0");
      if (tabIndexQuery) {
        nextTick(() => {
          nextTick(() => {
            tabIndex.value = tabIndexQuery;
            window.scrollTo(0, scrollY);
          });
        });
      }
      determineVisibility();
    });

    watch(
      () => sumario.value?.id,
      async (newId) => {
        if (newId && tabIndex.value === 1) {
          await cargarDiligencias();
        }
      },
      { immediate: true }
    );

    async function cargarDiligencias() {
      loading.value = true;
      try {
        await store.dispatch("sumario/fetchDiligencias", sumario.value.id);
        await filesQuery();
      } finally {
        loading.value = false;
      }
    }

    const handleIsShared = async (actuacionID) => {
      const { data } = await rest.get(
        `${process.env.VUE_APP_BACKEND_ENVIRONMENT}/actuacion-shared/${actuacionID}`
      );
      isShared.value = data;
    };

    const blockNavigationToAnotherTab = () => {
      const nodes = legalDataTab.value.$refs.content.lastChild.childNodes;
      nodes.forEach((li) => {
        if (li.nodeName !== "LI" || li.classList.contains("p-tabview-ink-bar")) return;
        if (getComputedStyle(li).position === "static") li.style.position = "relative";
        const overlay = document.createElement("div");
        Object.assign(overlay.style, {
          position: "absolute",
          inset: "0",
          zIndex: 2,
          cursor: "pointer",
        });
        overlay.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();
          const tabToRedirect = li.innerText.trim();

          if (tabIndex.value === 0) {
            cancelLegalDataButtonAction(tabToRedirect);
          } else if (tabIndex.value === 1) {
            cancelDateButtonAction(tabToRedirect);
          } else if (tabIndex.value === 2) {
            cancelDateButtonAction(tabToRedirect);
          } else if (tabIndex.value === 3) {
            cancelAffectedButtonAction(tabToRedirect);
          } else if (tabIndex.value === 4) {
            cancelVinculatedButtonAction(tabToRedirect);
          } else if (tabIndex.value === 5) {
            cancelEffectButtonAction(tabToRedirect);
          } else if (tabIndex.value === 6) {
            cancelIntervinienteButtonAction(tabToRedirect);
          }
        });
        li.appendChild(overlay);
      });
    };

    const removeTheBlockNavigationToAnotherTab = () => {
      const nodes = legalDataTab.value.$refs.content.lastChild.childNodes;
      nodes.forEach((li) => {
        if (li.nodeName !== "LI" || li.classList.contains("p-tabview-ink-bar")) return;
        const overlays = li.querySelectorAll("div");
        overlays.forEach((ov) => {
          if (ov.style && ov.style.position === "absolute" && ov.style.zIndex === "2") {
            li.removeChild(ov);
          }
        });
      });
    };

    const defineStateColor = (stateName) => {
      switch (stateName) {
        case "En Curso":
          return { backgroundColor: "#fffbeb", fontColor: "#d97706" };
        case "Vencida":
          return { backgroundColor: "#ffd2ca", fontColor: "#d20f39" };
        case "Finalizada":
          return { backgroundColor: "#daf8e6", fontColor: "#037331" };
      }
    };

    const onTabChange = async (event) => {
      const tabName =
        event.originalEvent?.target?.innerText ||
        event.originalEvent?.target?.textContent ||
        event.tab?.header ||
        "";
      if (route.query.scrollY) {
        router.replace({
          path: route.path,
          query: {},
        });
      }
      tabIndex.value = event.index;
      switch (tabName.trim()) {
        case "Datos Legales":
          loading.value = true;
          try {
            await store.dispatch("sumario/setSumario", sumario.value.id);

            const isUFI =
              sumario.value.formType?.includes("Unidades Fiscales") ||
              sumario.value.formType?.includes("UFI");

            const promises = [
              juzgadosStore.setAllJuzgados(),
              ufisStore.setUfis(),
              personalFiscalStore.setFiscales(),
              personalFiscalStore.setAyudantesFiscales(),
              modusOperandiStore.setModusOperandi(),
              sitioStore.setSitios(),
              articulosStore.setAllArticulos(),
              legalDataStore.fetchDatosLegales(sumario.value.id),
            ];
            if (isUFI) {
              promises.push(delitosStore.setDelitos());
            } else {
              promises.push(causaCaratulaStore.setCausasCaratulas());
            }

            await Promise.all(promises);
          } finally {
            loading.value = false;
          }
          break;
        case "Gestión de diligencias y archivos":
          loading.value = true;
          try {
            await store.dispatch("sumario/fetchDiligencias", sumario.value.id);
            await filesQuery();
          } finally {
            loading.value = false;
          }
          break;
        case "Fecha Hora y Ubicación":
          store.dispatch("sumario/resetUbicacionAction");
          loading.value = true;
          try {
            await store.dispatch("sumario/fetchMomentoUbicacion", sumario.value.id);
            nextTick(() => {
              setTimeout(() => {
                FechaUbiRef.value?.$refs?.map?.refreshMap();
              }, 300);
            });
          } finally {
            loading.value = false;
          }
          break;
        case "Afectados":
          loading.value = true;
          try {
            await affectedStore.fetchAffecteds(sumario.value.id);
          } finally {
            loading.value = false;
          }
          break;
        case "Vinculados":
          loading.value = true;
          try {
            await vinculatedStore.fetchVinculateds(sumario.value.id);
          } finally {
            loading.value = false;
          }
          break;
        case "Efectos":
          loading.value = true;
          try {
            await effectStore.fetchEfectos(sumario.value.id);
          } finally {
            loading.value = false;
          }
          break;
        case "Personal interviniente":
          loading.value = true;
          try {
            await intervinienteStore.fetchIntervinientes(sumario.value.id);
          } finally {
            loading.value = false;
          }
          break;
        case "Evidencias":
          evidenciasTabKey.value++;
          loading.value = true;
          try {
            await evidenciaStore.fetchEvidencias(sumario.value.id);
          } finally {
            loading.value = false;
          }
          break;
        case "Afectación Patrimonial":
          renderAfectation.value = true;
          afectacionStore.fetchAfectaciones(sumario.value.id);
          break;
      }
    };

    const formatNameUFI = (name) => {
      const regex = /^Unidades Fiscales de Investigaci[oó]n/i;
      if (regex.test(name)) {
        return `UFI ${name.replace(regex, "").trim()}`;
      }
      return name;
    };

    const activarProrroga = () => {
      mensaje.value = "Está seguro desea activar la prórroga por 5 Días?";
      buttomAceptar.value = { buttom: true, action: true };
      buttomCancelar.value = { buttom: true, action: false };
      aceptarLabel.value = "si";
      cancelarLabel.value = "no";
      ClickAceptar.value = () => {
        msjEnable.value = false;
        mensaje.value = "";
        updateStateActuacion(true);
        aceptarLabel.value = undefined;
        cancelarLabel.value = undefined;
      };
      msjEnable.value = true;
    };

    const isOnlineActuacion = () => {
      return offline.onlineMode && sumario.value.id?.search("offline-") != 0;
    };

    const changeStatusActuacion = () => {
      iconModal.value = {}; // indicamos que no queremos icono en este modal
      buttomAceptar.value = { buttom: true, action: true };
      buttomCancelar.value = { buttom: true, action: false }; // habilitamos boton para cancelar
      ClickAceptar.value = () => {
        msjEnable.value = false;
        mensaje.value = "";
        buttomAceptar.value = { buttom: true, action: false };
        buttomCancelar.value = { buttom: false, action: false };
        updateStateActuacion();
        disabledModifyStatusActuation.value = true;
      };
      mensaje.value =
        sumario.value.sumarioEstado != "Finalizada"
          ? "Seguro que desea dar por Finalizada la Actuacion ?"
          : "Si Reestablece esta Actuacion, la misma volvera a estar 'En Curso' o 'Vencida' segun corresponda, seguro desea continuar?";
      msjEnable.value = true;
    };

    const updateStateActuacion = async (activarProrroga = false) => {
      loading.value = true;
      let newEstadoActuacion;
      if (sumario.value.sumarioEstado == "Finalizada" || activarProrroga) {
        newEstadoActuacion = "En Curso";
      } else {
        newEstadoActuacion = "Finalizada";
      }
      let data = {
        ActuacionID: sumario.value.ActuacionID,
        //Si el estado actual es distinto a Finalizada, entonces el Usuario esta finalizando la Actuacion (solo tenemos esa opcion al dia 08-06-2022)
        NuevoEstado: newEstadoActuacion,
        Esclarecido: false,
      };
      try {
        let request = await axios.put(
          `${process.env.VUE_APP_BACKEND_ENVIRONMENT}/estado-actuacion/${sumario.value.id}`,
          data,
          { withCredentials: true, params: { method: "own" } }
        );
        if (request.data.error === "") {
          let iconModal = {
            type: "pi pi-check-circle",
            style: "font-size: 3em; color: rgb(89, 150, 29);",
          };
          if (activarProrroga) {
            finalizarCambioEstado(
              "Se activó la prórroga con éxito",
              iconModal,
              true,
              false,
              route.fullPath
            );
          } else {
            let mensaje =
              sumario.value.sumarioEstado != "Finalizada"
                ? "La Actuacion Se Finalizo con Exito"
                : "La Actuacion Se reestablecion con Exito";
            finalizarCambioEstado(mensaje, iconModal, true, false, "/sumario");
          }
        }
      } catch (e) {
        let iconModal = { type: "pi pi-exclamation-circle", style: "font-size: 3em; color: red;" };
        if (activarProrroga) {
          finalizarCambioEstado("No se pudo activar la prórroga", iconModal, true);
        } else {
          let mensaje =
            sumario.value.sumarioEstado != "Finalizada"
              ? "La Actuacion No se pudo Finalizar"
              : "La Actuacion no pudo Reestablecerse";
          finalizarCambioEstado(mensaje, iconModal, true, true);
        }
      }
      loading.value = false;
    };

    const finalizarCambioEstado = (msg, icon, mensajeEnable = false, error = false, routerPush) => {
      aceptarLabel.value = undefined;
      cancelarLabel.value = undefined;
      buttomCancelar.value = { buttom: false, action: false };
      buttomAceptar.value = { buttom: true, action: false, routerPush };
      iconModal.value = icon;
      err.value = error;
      mensaje.value = msg;
      msjEnable.value = mensajeEnable;
    };

    const closeModalFinalizacion = () => {
      msjFinalizacionEnable.value = false;
      mensajeFinalizacion.value = "";
      modalFinalizacionErrorRef.value.close();
    };

    const mostrarErrorFinalizacion = (msg) => {
      modalTypeFinalizacion.value = "warning";
      modalTitleFinalizacion.value = "Error";
      mensajeFinalizacion.value = msg;
      ClickAceptarFinalizacion.value = () => {
        msjFinalizacionEnable.value = false;
        mensajeFinalizacion.value = "";
        if (modalFinalizacionErrorRef.value) {
          modalFinalizacionErrorRef.value.close();
        }
      };
      msjFinalizacionEnable.value = true;
      if (modalFinalizacionErrorRef.value) {
        modalFinalizacionErrorRef.value.open();
      }
    };

    const deleteFile = async (file) => {
      const id = file.ActuacionArchivoID;
      let optionsDelete = {
        url: `${process.env.VUE_APP_BACKEND_ENVIRONMENT}/files/sumario/${id}`,
      };
      try {
        loading.value = true;
        await rest.del(optionsDelete);
        await deleteGenericDataFromCached("files " + sumario.id);
        await filesQuery();
        RemoveFiles();
      } catch (e) {
        console.error(e);
        loading.value = false;
      }
      sortByDate();
    };

    const fechaCreacion = (fecha) => {
      let fechaAux = new Date(fecha); //la fecha viene en formato string por eso la convertimos
      let fechaCambioHorarioBd = new Date("2022-04-08 19:00:45"); //esta es la fecha y hora a partir de la cual se actualizo la zona horaria de la Api
      if (fechaAux < fechaCambioHorarioBd) {
        let fechaYhoraAux = fechaAux.getTime() - 180 * 60000; //le restamos 3 horas, por que la mayoria de ellas, se guardaron con 3 horas +, ya que en argentina estamos -3
        let FechayHoraCreacion = new Date(fechaYhoraAux); //volvemos a formato fecha

        let fechaCreacion = FechayHoraCreacion.toLocaleDateString("es-AR"); //extraemos la fecha
        let horaCreacion = FechayHoraCreacion.toLocaleTimeString("es-AR"); //extraemos la hora

        return fechaCreacion + " " + horaCreacion;
      } else {
        let fechaCreacion = fechaAux.toLocaleDateString("es-AR"); //extraemos la fecha
        let horaCreacion = fechaAux.toLocaleTimeString("es-AR"); //extraemos la hora
        return fechaCreacion + " " + horaCreacion;
      }
    };

    const deleteActuacion = async () => {
      closeModalTemplate(ModalConfirmDeleteActuacion);
      loading.value = true;
      try {
        store.dispatch("sumarioList/loadingUpdate", true);
        let resp = await store.dispatch("sumario/deleteActuacion", sumario.value.id);
        if (resp == true) {
          await store.dispatch("sumarioList/deleteActuaciones", sumario.value.id);
          await store.dispatch("sumarioList/resetActuaciones");
          toast.success("La actuación fue eliminada correctamente");
        }
        loading.value = false;
      } catch (error) {
        console.error(error);
      } finally {
        router.push({ path: `/actuaciones/list` });
      }
    };

    const btnEnvio = async () => {
      if (!sumario.value?.actuacionUsuarioDependenciaID) {
        toast.error(
          "No se encontró información válida de la actuación actual para continuar con el envío."
        );
        return;
      }
      isConfirmDisabled.value = true;
      let datos = {
        UpdatePrevious: { DependenciaID: sumario.value.DependenciaID }, //enviamos los datos nescesarios para actualizar el registro anterior(en este caso solo nescesita el Id de la dependencia actual del sumario)
        LoadNew: {
          DependenciaID: dependencia.value.id,
          Numeroextracto: sumario.value.causaNumero
            ? sumario.value.causaNumero
            : sumario.value.ActuacionUsuarioDependencia.find((e) => e.Fechahasta === null)
                .Numeroextracto,
        }, //enviamos el Id de la nueva Dependencia
      };
      isDisabled.btnEnviar = true;
      try {
        let request = await axios.post(
          `${process.env.VUE_APP_BACKEND_ENVIRONMENT}/actuacion-usuario-dependencia/${sumario.value.actuacionUsuarioDependenciaID}`,
          datos,
          { withCredentials: true, params: { method: "own" } }
        );
        await store.dispatch("sumarioList/get", { accion: "inicio" });

        if (request.data.error === "" && request.status === 200) {
          router.push({ path: `/actuaciones/list` });
          toast.success("La actuación fue enviada correctamente a la dependencia.");
        }
      } catch (error) {
        console.error(error);
        toast.error(
          "Ocurrió un error al intentar enviar la actuación. Intente nuevamente o contacte al administrador."
        );
      }
    };

    //El siguiente metodo habilita los botones relacionados a la actuacion
    const authorizedUserActuacion = (aplicaSobre = []) => {
      let tiposUserAutorizados = aplicaSobre;
      let propietario = false;
      if (aplicaSobre.includes("SecretarioActual")) {
        //si el usuario logeado es el secretario actual de la actuacion entonces le permitimos editar/elimar
        propietario = sumario.value?.ActuacionUsuarioDependencia?.find((e) => {
          if (e.NombreUsuario == user.value.userdata.usuarioNombre && e.Fechahasta == null) {
            return true;
          }
        });
      }
      if (aplicaSobre.includes("Super User")) {
        // en caso de ser algo que solo los Super Usuarios puedan ver
        tiposUserAutorizados.push("Super Usuario de E3", "Super User", "User Tester");
      }
      if (propietario || tiposUserAutorizados.includes(user.value.userdata.tipoUsuario)) {
        return true;
      } else {
        return false;
      }
    };

    //El siguiente metodo habilita los botones relacionados a las diligencias
    const authorizedUserDiligencia = (diligenciaID = null) => {
      let propietario = diligenciaID == user.value.uid ? true : false;
      //si el usuario es el SuperUserE3 que pueda verlos
      //Y si es un Jefe de sumario tambien puede Editar/eliminar
      if (
        propietario ||
        user.value.userdata.usuarioNombre == "SuperUserE3" ||
        user.value.userdata.claseDeUsuario == "UsuarioFiscal" ||
        user.value.userdata.permisos.find(
          (element) =>
            element.TipoUsuarioID == "TipoUsuarioJefeDeSumario" ||
            element.TipoUsuarioID == "UserTester" ||
            element.TipoUsuarioID == "SuperUser"
        ) != undefined
      ) {
        return true;
      } else {
        return false;
      }
    };

    const apellidoNombre = (apellido, nombre) => {
      var respuesta = "";
      //apellido y nombre pueden venir de realizar un "concat" en sumario.js, lo que implica que null puede ser tomado como un string
      respuesta =
        apellido == "null" || apellido == null || apellido == "Sin Apellido Especificado"
          ? ""
          : apellido;
      respuesta =
        nombre == "null" || nombre == null || nombre == "Sin Apellido Especificado"
          ? respuesta
          : respuesta == ""
            ? nombre
            : respuesta + " ," + nombre;
      return respuesta;
    };

    const deleteDiligencia = async (diligenciaId) => {
      loading.value = true;
      let resp = await store.dispatch("sumario/deleteDiligencia", diligenciaId);
      if (resp == true) {
        let indice = filesAndDiligences.value.findIndex(
          (element) => element.DiligenciaID == diligenciaId
        );
        filesAndDiligences.value.splice(indice, 1);
      }
      loading.value = false;
    };

    const editDiligencia = (diligenciaId) => {
      changeNameInStore(formType.value);
      const scrollY = window.scrollY;
      const tabIndexQuery = tabIndex.value;
      router.push({
        name: "actuacion-edit-print",
        params: {
          pathName: actuacionType.value,
          id: diligenciaId,
        },
        query: {
          scrollY,
          tabIndex: tabIndexQuery,
        },
      });
    };

    const seeDiligencia = (diligenciaId) => {
      //Bloqueando la vista del PDF para que no se vea la diligencia de abajo
      document.querySelector("#app")?.classList.add("iframe-container");
      countPrint(diligenciaId);
      changeNameInStore(formType.value);
      const scrollY = window.scrollY;
      const tabIndexQuery = tabIndex.value;
      router.push({
        path: `/actuaciones/${actuacionType.value}/print/${diligenciaId}`,
        query: {
          scrollY,
          tabIndex: tabIndexQuery,
        },
      });
    };

    const countPrint = (DiligenciaID) => {
      let fullDate = new Date();

      let date = `${fullDate.getFullYear()}-${
        fullDate.getMonth() + 1
      }-${fullDate.getDate()} ${fullDate.getHours()}:${fullDate.getMinutes()}:00`;
      store.dispatch("sumario/addCounterPrint", {
        DiligenciaID: DiligenciaID,
        ComisariaID: user.value.dependencia,
        Paginas: 1,
        FechaIniVig: date,
      });
    };

    const updateFiles = (event) => {
      if (!offline.onlineMode || resumen.value.ActuacionID.search("offline-") == 0) {
        toast.error("OFFLINE SIIS: No se pueden descargar o subir archivos en modo offline.");
        return;
      }
      formData.value = new FormData();
      event.files.map((file) => {
        if (
          file.type !== "application/pdf" &&
          file.type !== "image/jpeg" &&
          file.type !== "image/png"
        ) {
          err.value =
            "Al menos uno de los archivos es incompatible con los formatos permitidos (JPG, PNG y/o PDF)";
          RemoveFiles();
          FileUpload.value.clear();
          setTimeout(() => {
            err.value = false;
          }, 5000);
          return;
        }
        formData.value.append("userfile[]", file, file.name);
      });
    };

    const RemoveFiles = () => {
      formData.value = null;
    };

    const myUploader = async () => {
      if (
        user.value.userdata.tipoUsuario === "Dpto.Criminalistica" ||
        user.value.userdata.tipoUsuario === "Lab. Informatico Forense"
      ) {
        emailBody.value = "emailFileHtml";
        sendAllMails();
      }
      loading.value = true;
      try {
        if (!offline.onlineMode || resumen.value.ActuacionID.search("offline-") == 0) {
          toast.error("OFFLINE SIIS: No se pueden descargar o subir archivos en modo offline.");
          return;
        }
        let optionsPost = {
          url: `${process.env.VUE_APP_BACKEND_ENVIRONMENT}/files/sumario?ActuacionID=${resumen.value.ActuacionID}`,
          formData: formData.value,
          headers: { "Content-Type": "multipart/form-data" },
        };
        await rest.post(optionsPost);
        await deleteGenericDataFromCached("files " + sumario.value.id);
        await filesQuery();
        RemoveFiles();
        sortByDate();
      } catch (e) {
        console.error("err", e);
        err.value = "Error al subir archivos";
        setTimeout(() => {
          err.value = false;
        }, 5000);
        await filesQuery();
        RemoveFiles();
      }
    };

    const processFiles = (data) => {
      filesAndDiligences.value = [];
      for (let i = 0; i < sumario.value.diligencia.length; i++) {
        let diligence = { ...sumario.value.diligencia[i] };

        filesAndDiligences.value.push(diligence);
      }
      for (let i = 0; i < data.length; i++) {
        if (data[i].OrderTable !== null) {
          data[i].OrderTablePrint = data[i].OrderTable;
        } else {
          data[i].OrderTablePrint = null;
        }
        let file = { file: true, ...data[i], OrderTablePrint: data[i].OrderTable };
        filesAndDiligences.value.push(file);
      }
      if (
        orderBy.value.nombre === "Impresión" &&
        filesAndDiligences.value.some((item) => item.OrderTablePrint !== null)
      ) {
        sortTheOrderPrintNulls();
      } else {
        filesAndDiligencesByDate.value = filesAndDiligences.value.sort(sortByDate.value);
      }
      files.value = data;
    };

    const filesQuery = async (id = resumen.value.ActuacionID) => {
      if (!id) {
        id = route.params.id;
      }
      try {
        loading.value = true;
        let resp;
        let fdata = [];
        if (!offline.onlineMode) {
          toast.error("OFFLINE SIIS: No se pueden descargar o subir archivos en modo offline.");
        } else {
          resp = await rest.get({
            url: `${process.env.VUE_APP_BACKEND_ENVIRONMENT}/files/sumario/?search={"ActuacionID": [{"operator": "=", "value": "${id}"}]}`,
          });
          fdata = resp.data.data;
        }
        processFiles(fdata);
        loading.value = false;
      } catch (error) {
        console.log("filesQuery err", error);
      }
    };

    const viewFile = (file) => {
      return `${process.env.VUE_APP_BACKEND_ENVIRONMENT}/files/sumario/${file.ActuacionArchivoID}?view=true`;
    };

    const filterDependencia = (event) => {
      filteredDependencia.value = dependenciaList.value.filter(
        (item) => item.dependencia.toLowerCase().search(event.query.toLowerCase()) >= 0
      );
    };

    const onRowReorder = (event) => {
      filesAndDiligences.value = event.value;
    };

    const sortByDate = (a, b) => {
      //Selecciono el tipo de ID por que si se trata de un archivo accedera a ActuacionArchivoID y DiligenciaID no existira; lo mismo a la inversa
      if (!a || !b) return 0;
      let aFiv;
      let bFiv;

      if (!a.Fechainivig || a.Fechainivig === undefined) {
        aFiv = "1999-01-01 00:00:00";
      } else {
        aFiv = a.Fechainivig;
      }
      if (!b.Fechainivig || b.Fechainivig === undefined) {
        bFiv = "1999-01-01 00:00:00";
      } else {
        bFiv = b.Fechainivig;
      }
      let id = a["DiligenciaID"] || a["ActuacionArchivoID"];
      if (id.search("offline-") === 0) return 1;
      var reA = /[^a-zA-Z]/g;
      var reN = /[^0-9]/g;
      var aA = aFiv.replace(reA, "");
      var bA = bFiv.replace(reA, "");
      if (aA === bA) {
        var aN = parseInt(aFiv.replace(reN, ""), 10);
        var bN = parseInt(bFiv.replace(reN, ""), 10);
        return aN === bN ? 0 : aN < bN ? 1 : -1;
      } else {
        return aA < bA ? 1 : -1;
      }
    };

    const sortByOrderTablePrint = (a, b) => {
      var reA = /[^a-zA-Z]/g;
      var reN = /[^0-9]/g;
      var aA = a.OrderTablePrint.replace(reA, "");
      var bA = b.OrderTablePrint.replace(reA, "");
      if (aA === bA) {
        var aN = parseInt(a.OrderTablePrint.replace(reN, ""), 10);
        var bN = parseInt(b.OrderTablePrint.replace(reN, ""), 10);
        return aN === bN ? 0 : bN < aN ? 1 : -1;
      } else {
        return bA < aA ? 1 : -1;
      }
    };

    watch(
      () => DescripcionFinalizacion.value,
      (newValue) => {
        if (newValue.length >= 200) {
          errorDescripcion.value = "Máximo de caracteres 200";
        } else {
          errorDescripcion.value = null;
        }
      }
    );

    const handleFinalizarActuacion = async () => {
      closeModalTemplate(ModalRefEsclarecido);
      let data = {
        NuevoEstado: "Finalizada",
        Esclarecido: isEsclarecido.value,
        DescripcionFinalizacion: DescripcionFinalizacion.value,
      };
      loading.value = true;
      try {
        let request = await rest.put({
          url: `/estado-actuacion/${sumario.value.id}`,
          formData: data,
          params: { method: "own" },
          success: "",
        });
        if (request.data.error === "") {
          let icon = {
            type: "pi pi-check-circle",
            style: "font-size: 3em; color: rgb(89, 150, 29);",
          };
          let msg = "¡La actuación se finalizó correctamente!";
          finalizarCambioEstado(msg, icon, true, false, "/actuaciones/list");
        }
      } catch (e) {
        let icon = { type: "pi pi-exclamation-circle", style: "font-size: 3em; color: red;" };
        let msg = "La Actuacion No se pudo Finalizar";

        if (e && e.data) {
          msg = e.data.message || e.data.error || msg;
        }

        mostrarErrorFinalizacion(msg);
      }
      ((isEsclarecido.value = null), (DescripcionFinalizacion.value = ""));
      loading.value = false;
    };

    const updateOrderTableDataBase = () => {
      let i = 1;
      filesAndDiligences.value.map((item) => {
        if (item.file === undefined) {
          let payload = { OrderTablePrint: i, diligenciaID: item.DiligenciaID, name: item.Nombre };
          filesAndDiligences.value[i - 1].OrderTablePrint = i.toString();
          store.dispatch("sumario/editOrderTablePrintFromDiligencia", payload);
          i++;
        }
        if (item.file === true) {
          let payload = {
            OrderTablePrint: i,
            ActuacionArchivoID: item.ActuacionArchivoID,
            name: item.Filename,
            FechaCreacion: item.FechaCreacion,
            Extension: item.Extension,
          };
          filesAndDiligences.value[i - 1].OrderTablePrint = i.toString();
          store.dispatch("sumario/editOrderTableForFiles", payload);
          i++;
        }
      });
    };

    const sortTheOrderPrintNulls = () => {
      let i = 1;
      filesAndDiligencesByDate.value = filesAndDiligences.value.sort(sortByDate).reverse();
      let amountOfNullOrderPrints = filesAndDiligencesByDate.value.filter(
        (fileOrDiligence) => fileOrDiligence.OrderTablePrint === null
      ).length;
      const newOrdenPrint = filesAndDiligencesByDate.value.length - amountOfNullOrderPrints;
      filesAndDiligencesByDate.value.map((fileOrDiligence) => {
        if (fileOrDiligence.OrderTablePrint === null) {
          fileOrDiligence.OrderTablePrint = (newOrdenPrint + i).toString();
          i++;
        }
      });
      filesAndDiligences.value = filesAndDiligencesByDate.value.sort(sortByOrderTablePrint);
    };

    const openModalTemplate = (type) => {
      type.value?.open();
    };

    const closeModalTemplate = (type) => {
      if (type.value) {
        type.value?.close();
      } else {
        type.close();
      }
    };

    const openModalEsclarecido = () => {
      openModalTemplate(ModalRefEsclarecido);
      closeModalTemplate(ModalRefConfirm);
    };

    const verifyAmountOfDiligences = async () => {
      loading.value = true;
      await store.dispatch("sumario/fetchDiligencias", sumario.value.id);
      await filesQuery();
      loading.value = false;
      if (filesAndDiligences.value.length >= 3) {
        openModalTemplate(ModalRefConfirm);
      } else {
        openModalTemplate(ModalRefInform);
      }
    };

    const changeNameInStore = (formType) => {
      const viewConfig = actuacionesConfig.find((config) => config.path === "/actuaciones/view/");
      if (viewConfig && viewConfig.actuaciones) {
        const foundActuacion = viewConfig.actuaciones.find(
          (actuacion) => actuacion.nameInStore === formType
        );

        if (foundActuacion) {
          actuacionType.value = foundActuacion.pathName;
        } else {
          console.log(
            "No se encontró ninguna coincidencia para el formType proporcionado en /actuaciones/view/."
          );
          actuacionType.value = null;
        }
      } else {
        console.log("No se encontró la configuración para /actuaciones/view/.");
      }
    };

    const goToAgregarDiligencia = async () => {
      changeNameInStore(formType.value);
      const scrollY = window.scrollY;
      const tabIndexQuery = tabIndex.value;

      if (actuacionType.value) {
        isLoadingData.value = true;
        await store.dispatch("sumario/setSumario", ActuacionID.value);
        await store.dispatch("sumario/fetchAfectados", ActuacionID.value);
        await store.dispatch("sumario/fetchVinculados", ActuacionID.value);
        await store.dispatch("sumario/fetchMomentoUbicacion", sumario.value.id);
        await store.dispatch("sumario/fetchEfectos", sumario.value.id);
        if (mostrarPersonalInterviniente.value) {
          await intervinienteStore.fetchIntervinientes(sumario.value.id);
        }
        if (mostrarAfectacionPatrimonial.value) {
          await afectacionStore.fetchAfectaciones(sumario.value.id);
          store.dispatch("sumario/setAfectaciones", afectacionStore.afectacionesPatrimoniales);
        }
        loading.value = false;
        router.push({
          path: `/actuaciones/new/${actuacionType.value}/${sumario.value.id}/addDiligencia`,
          query: {
            scrollY,
            tabIndex: tabIndexQuery,
          },
        });
      } else {
        console.log("No se pudo encontrar un pathName para formType:", formType.value);
      }
    };

    //revisar esto, es para accede a $rest.sendEmail de siis_utils
    const { proxy } = getCurrentInstance();
    const $rest = proxy.$rest;

    const emailBodyContent = computed(() => {
      return emailBody.value === "emailEvidenceHtml"
        ? emailEvidenceHtml.value
        : emailFileHtml.value;
    });

    const sendMailToDependency = async (slotProps) => {
      indexEmailButtonDisabled.value = slotProps?.index;
      let emailAddressee = await getDependencyEmailFromStore();
      await $rest.sendEmail({
        sender: "siisadmin@policia.sanjuan.gob.ar",
        addressee: [emailAddressee],
        subject: generateEmailSubject(),
        emailBody: emailBodyContent.value,
      });
      indexEmailButtonDisabled.value = null;
    };

    const generateEmailSubject = () => {
      if (user.value.userdata.tipoUsuario === "Dpto.Criminalistica") {
        return sumario.value.causaNumero + " - PERICIA CRIMINALÍSTICA";
      }
      if (user.value.userdata.tipoUsuario === "Lab. Informatico Forense") {
        return sumario.value.causaNumero + " - INFORME TÉCNICO LABORATORIO INFORMÁTICO FORENSE";
      }
      return sumario.value.causaNumero + " ";
    };

    const getDependencyEmailFromStore = async () => {
      await store.dispatch("sumario/getDependencyEmail", sumario.value.dependenciaID);
      return sumario.value.dependencyEmail;
    };

    const determineEmailButtonVisibility = (buttonData) => {
      let isFile = buttonData.file;
      if (!isFile) return false;
      switch (buttonData.TipoUsuario) {
        case "Dpto.Criminalistica":
          return user.value.userdata.tipoUsuario === "Dpto.Criminalistica" ? true : false;
        case "Lab. Informatico Forense":
          return user.value.userdata.tipoUsuario === "Lab. Informatico Forense" ? true : false;
        case "":
          return false;
        default:
          return false;
      }
    };

    const getDefaultEvidence = async () => {
      evidence.value = "";
      let resp = await rest.get({
        url: `${process.env.VUE_APP_BACKEND_ENVIRONMENT}/actuacion-evidencia?search={"ActuacionID":[{"operator":"=","value":"${resumen.value.ActuacionID}"}]}`,
      });
      if (resp.data.data[0]?.Url !== undefined) {
        evidence.value = ensureHTTP(resp.data.data[0]?.Url).replace(/\s+/g, "");
      }
    };

    const ensureHTTP = (url) => {
      if (!url.includes("https://") && !url.includes("http://")) {
        return "https://" + url;
      }
      return url;
    };

    const cancelDateButtonAction = (tabToRedirectFromListener) => {
      if (tabToRedirectFromListener === undefined) {
        tabToRedirect.value = null;
      } else {
        tabToRedirect.value = tabsMap.value.find((u) => u.name === tabToRedirectFromListener);
      }
      FechaUbiRef.value.modalMessage =
        "Si cambiás de pestaña ahora, todos los datos editados se perderán y no podrán recuperarse. ¿Deseás continuar?";
      FechaUbiRef.value.customButtons = true;
      FechaUbiRef.value?.modalRefSave.open();
    };

    const saveDateButtonAction = async () => {
      saveLoading.value = true;
      let internetConnection = await verifyInternetConnection();
      if (!internetConnection) {
        FechaUbiRef.value?.modalRefDateAndLocationError.open();
        return;
      } else {
        saveDataInStore();
        callPutEndpoint();
        const ubicationDetailsAreEmpty = FechaUbiRef?.value?.ubicationDetailsEmpty(
          datesAndLocationsStore.dateAndLocation.preUbicacion
        );
        FechaUbiRef.value.ubicationDetails = !ubicationDetailsAreEmpty;
      }
    };

    const callPutEndpoint = async () => {
      try {
        saveLoading.value = true;
        let options = await orderDataToSave();
        await functionsEditMode.methodPut(options);
        viewMode.value = true;
        editMode.value = false;
        FechaUbiRef.value.modalMessage =
          "La información se ha guardado correctamente. Para regresar a la vista anterior, haga click en 'Continuar'.";
        FechaUbiRef.value?.modalRefSaveSuccess.open();
      } catch (error) {
        console.error("Falló:", error);
        FechaUbiRef.value?.modalRefDateAndLocationError.open();
      }
      saveLoading.value = false;
    };

    const orderDataToSave = async () => {
      const orientation = datesAndLocationsStore.dateAndLocation.preUbicacion.orientacion?.nombre;
      let dataToSave = {
        url: `${process.env.VUE_APP_BACKEND_ENVIRONMENT}/momento-ubicacion/${router.history.current.params.id}`,
        formData: {
          MomentoUbicacion: {
            Barrio: datesAndLocationsStore.dateAndLocation.preUbicacion.barrio,
            Calle: datesAndLocationsStore.dateAndLocation.preUbicacion.calle,
            Casa: datesAndLocationsStore.dateAndLocation.preUbicacion.casa,
            Departamento: datesAndLocationsStore.dateAndLocation.preUbicacion.departamento?.nombre,
            Latitud: datesAndLocationsStore.dateAndLocation.preUbicacion.coordinates.lat,
            Longitud: datesAndLocationsStore.dateAndLocation.preUbicacion.coordinates.lng,
            MomentoFechaHoraDesde: generateDate(datesAndLocationsStore.dateAndLocation.moment.date),
            MomentoFechaHoraHasta: generateDate(
              datesAndLocationsStore.dateAndLocation.moment.date2
            ),
            Numero: datesAndLocationsStore.dateAndLocation.preUbicacion.numero,
            Orientacion: orientation === undefined ? "" : orientation,
            Piso: datesAndLocationsStore.dateAndLocation.preUbicacion.piso,
            Sector: datesAndLocationsStore.dateAndLocation.preUbicacion.sector,
            Zona: datesAndLocationsStore.dateAndLocation.preUbicacion.zona,
          },
        },
        ContentType: "text/plain",
      };
      return dataToSave;
    };

    const saveDataInStore = () => {
      const momentData = FechaUbiRef.value.generateMomentAndPreUbicacion()?.momentData;
      const preUbicacionData = FechaUbiRef.value.generateMomentAndPreUbicacion()?.preUbicacionData;
      datesAndLocationsStore.updateData("moment", momentData);
      datesAndLocationsStore.updateData("preUbicacion", preUbicacionData);
    };

    const generateDate = (data) => {
      if (typeof data == "string") data = new Date(data);
      if (data === null) return "";
      var fecha = data.toISOString().slice(0, 10).replace("T", " ");
      var dia = new Date(data);
      var hora = dia.getHours() + ":" + dia.getMinutes() + ":" + dia.getSeconds();
      var fechaYhora = fecha + " " + hora;
      return fechaYhora;
    };

    const sendMailToUFIAndMpftesting = async () => {
      let translatedFormTypeName = generalFunctions.translateNameFromFormType(formType.value);
      let emailUFI = viewData.value[translatedFormTypeName].emailUFI;
      if (emailUFI === undefined) return;
      if (process.env.VUE_APP_BACKEND_ENVIRONMENT.includes("siis.policiadesanjuan.gob.ar")) {
        await $rest.sendEmail({
          sender: "siisadmin@policia.sanjuan.gob.ar",
          addressee: [emailUFI, "mpftesting.24@gmail.com"],
          subject: generateEmailSubject(),
          emailBody: emailBody.value,
        });
      }
    };

    const sendAllMails = async (slotProps) => {
      await sendMailToDependency(slotProps);
      await sendMailToUFIAndMpftesting();
    };

    const determineActionButtonsVisibility = (item) => {
      let itemIsVisible = true;
      if (item.data.TipoUsuario === "Dpto.Criminalistica") {
        itemIsVisible = $rest.esTipoUsuario(
          [
            "Dpto.Criminalistica",
            "Lab. Informatico Forense",
            "User Tester",
            "Super User",
            "Ayudante Fiscal",
            "Fiscal",
            "Fiscal General",
            "Supervisor",
            "Fiscal General",
            "Administrativo",
            "Policia Investigador",
          ],
          user.value
        );
      }
      return itemIsVisible;
    };

    const getItems = () => {
      const formTypesPermitidos = [
        "Unidades Fiscales de Investigación Delitos Contra la Propiedad por Denuncia",
        "Unidades Fiscales de Investigación Delitos Genéricos por Denuncia",
        "Unidades Fiscales de Investigacion Flagrancia",
        "Unidades Fiscales de Investigación Delitos Genéricos por Oficio",
        "Unidades Fiscales de Investigación Delitos Contra la Propiedad por Oficio",
      ];
      const tipoUsuario = user.value.userdata.tipoUsuario;
      const estadoActuacion = sumario.value?.sumarioEstado;
      const esFinalizada = estadoActuacion === "Finalizada";
      const permisos = permisosPorUsuario[tipoUsuario] || [];
      return permisos
        .filter((accion) => {
          if (accion === "Finalizar instrucción" && esFinalizada) {
            return false;
          }
          if (
            accion === "Cambiar tipo de actuación" &&
            !formTypesPermitidos.includes(formType.value)
          ) {
            return false;
          }
          return true;
        })
        .map((accion) => {
          return {
            ...acciones[accion],
            command: () => {
              acciones[accion].command();
            },
          };
        });
    };

    const editarActuacion = async () => {
      isLoadingData.value = true;

      await store.dispatch("sumario/setSumario", ActuacionID.value);
      await store.dispatch("sumario/fetchDiligencias", sumario.value.id);
      await store.dispatch("sumario/fetchAfectados", ActuacionID.value);
      await store.dispatch("sumario/fetchVinculados", ActuacionID.value);
      await store.dispatch("sumario/fetchMomentoUbicacion", sumario.value.id);
      await store.dispatch("sumario/fetchEfectos", sumario.value.id);

      if (mostrarPersonalInterviniente.value) {
        await intervinienteStore.fetchIntervinientes(sumario.value.id);
      }
      if (mostrarAfectacionPatrimonial.value) {
        await afectacionStore.fetchAfectaciones(sumario.value.id);
        store.dispatch("sumario/setAfectaciones", afectacionStore.afectacionesPatrimoniales);
      }

      changeNameInStore(formType.value);
      await store.dispatch("editMode/prepareActuationForEdition", sumario.value);
      await store.dispatch("sumario/setEditMode", true);
      router.push("/actuaciones/edit/" + actuacionType.value + "/initial");
    };

    const switchActuacion = async () => {
      isConfirmDisabled.value = true;
      const data = {
        Fechainicio: sumario.value.fechaCertificadoDenuncia,
        Numero: resumen.value.numeroSumario,
        DenunciaID: resumen.value.ActuacionID,
        TiposumarioID: actuacionIDforChange.value,
        DependenciaID: sumario.value.DependenciaID,
      };
      try {
        let request = await axios.put(
          `${process.env.VUE_APP_BACKEND_ENVIRONMENT}/actuacion/${sumario.value.id}?method=methodCommon`,
          data,
          { withCredentials: true }
        );
        if (request.data.error === "") {
          ModalRefSwitchActuacion.value.close();
          toast.success("Se cambio el tipo de actuación");
          setTimeout(() => {
            location.reload();
          }, 1500);
        }
      } catch (error) {
        ModalRefSwitchActuacion.value.close();
        toast.error("Error: No se realizó el cambio de actuación");
      } finally {
        isConfirmDisabled.value = false;
      }
    };

    const onSave = () => {
      if (router.history.current.fullPath.includes("/actuaciones/view/")) {
        saveInViewMode();
      } else {
        router.push("/actuaciones/new/" + actuacionType.value + "/initial");
      }
    };

    const closeErrorModal = () => {
      FechaUbiRef.value?.modalRefDateAndLocationError.close();
    };

    const saveInViewMode = () => {
      FechaUbiRef.value?.modalRefSaveSuccess.close();
      removeTheBlockNavigationToAnotherTab();

      if (tabIndex.value === 5) {
        effectStore.startView();
      }

      return;
    };

    const cancelContinueButtonAction = () => {
      saveDataInStore();
      FechaUbiRef.value.ubicationDetails = !FechaUbiRef?.value?.ubicationDetailsEmpty(
        datesAndLocationsStore.dateAndLocation.preUbicacion
      );
      if (tabToRedirect?.value !== null && tabToRedirect?.value !== undefined)
        tabIndex.value = tabToRedirect.value.id;
      viewMode.value = true;
      editMode.value = false;
      FechaUbiRef.value?.modalRefSave.close();
      removeTheBlockNavigationToAnotherTab();
      return;
    };

    const confirmDelete = (file, type) => {
      fileData.value = file;
      itemTypeToDelete.value = type;
      modalRefMessage.value = `¿Está seguro de que desea eliminar ${
        type === "archivo" ? "este archivo" : "esta diligencia"
      }?`;
      ModalRefDelete.value.open();
    };

    const deleteConfirmed = (isActuacion) => {
      if (isActuacion) {
        deleteActuacion();
        return;
      }
      if (fileData.value && itemTypeToDelete.value === "archivo") {
        deleteFile(fileData.value);
      } else if (fileData && itemTypeToDelete.value === "diligencia") {
        deleteDiligencia(fileData.value);
      }
      ModalRefDelete.value.close();
      fileData.value = null;
      itemTypeToDelete.value = null;
    };

    const cancelDelete = () => {
      fileData.value = null;
      itemTypeToDelete.value = null;
      ModalRefDelete.value.close();
    };

    const handleShareActuacion = async (confirm) => {
      if (confirm) {
        loadingShare.value = true;
        try {
          const formData = new FormData();
          formData.append("action", "share");
          formData.append("SumarioID", sumario.value?.id);
          formData.append("UsuarioID", user.value.uid);
          formData.append("DependenciaID", dependenciaForShare.value);
          const optionsPost = {
            url: `${process.env.VUE_APP_BACKEND_ENVIRONMENT}/actuacion-usuario-dependencia?method=own`,
            formData,
          };
          await rest.post(optionsPost);
        } catch (error) {
          console.error(error);
          toast.error("No se pudo compartir la instrucción");
        } finally {
          dependenciaForShare.value = null;
          loadingShare.value = false;
          closeModalTemplate(ModalShareConfirm);
          await handleIsShared(sumario.value.id);
        }
        return;
      }
      closeModalTemplate(ModalRefShare);
      openModalTemplate(ModalShareConfirm);
    };

    watch(
      () => orderBy.value,
      () => {
        if (orderBy.value.nombre === "Fecha") {
          sortByDate();
        } else if (
          orderBy.value.nombre === "Impresión" &&
          filesAndDiligences.value.some((item) => item.OrderTablePrint !== null)
        ) {
          sortTheOrderPrintNulls();
        } else {
          filesAndDiligences.value = filesAndDiligences.value.sort(sortByDate);
        }
      }
    );

    watch(
      () => resumen.value.ActuacionID,
      (newVal) => {
        if (newVal !== null) {
          getDefaultEvidence();
        }
      }
    );
    watch(
      () => sumario.value.diligencia,
      (nuevasDiligencias) => {
        processFiles(files.value || []);
        loading.value = false;
      }
    );

    /**
     * Lógica de Efectos, (mostrar botones correspondientes y emitir acciones hacia el store)
     */
    const effectStore = useEffectStore();
    const effectModalRef = ref(null);
    const actionToDo = ref(null);

    const effectModalData = ref({
      title: "",
      message: "",
      modalType: "",
      showSecondaryButton: true,
      buttonLabels: [],
      onConfirm: () => {},
      onCancel: () => {},
    });

    const showEliminarEfecto = () => {
      actionToDo.value = "delete";
      effectModalData.value = {
        title: "Eliminar Efecto",
        message: "¿Está seguro de eliminar este efecto? Esta acción no se puede deshacer.",
        modalType: "delete",
        showSecondaryButton: true,
        buttonLabels: ["Eliminar", "Cancelar"],
        onConfirm: () => {
          effectStore.handleDeleteEffect();
          effectModalRef.value.close();
        },
        onCancel: () => {
          effectModalRef.value.close();
        },
      };

      effectModalRef.value.open();
    };

    const showCancelModal = () => {
      actionToDo.value = "cancel";
      effectModalData.value = {
        title: "Cancelar carga de datos",
        message:
          "Si cancelas ahora, la información ingresada se perderá y no podrá recuperarse. ¿Deseas continuar con la cancelación?",
        modalType: "warning",
        showSecondaryButton: true,
        onConfirm: () => {
          effectStore.selectFirst();
          effectStore.startView();
          effectModalRef.value.close();
        },
        onCancel: () => {
          effectModalRef.value.close();
        },
      };

      effectModalRef.value.open();
    };

    const showSuccessModal = () => {
      actionToDo.value = "create";
      effectModalData.value = {
        title: "¡Los datos se guardaron con éxito!",
        message: "",
        modalType: "success",
        showSecondaryButton: false,
        onConfirm: () => {
          effectStore.selectFirst();
          effectStore.startView();
          effectModalRef.value.close();
        },
        onCancel: () => {},
      };
      effectModalRef.value.open();
    };

    const cancelEffectButtonAction = (tabToRedirectFromListener) => {
      if (tabToRedirectFromListener === undefined) {
        tabToRedirect.value = null;
      } else {
        tabToRedirect.value = tabsMap.value.find((u) => u.name === tabToRedirectFromListener);
      }

      actionToDo.value = "cancel";

      const isCreating = effectStore.isCreate;
      const isEditing = effectStore.isEdit;

      let title, message, buttonLabels;

      if (isCreating) {
        title = "Cancelar creación de efecto";
        message =
          "Estás por salir sin guardar el nuevo efecto. Si volvés ahora, toda la información que ingresaste se perderá y no podrá recuperarse. ¿Deseás continuar?";
        buttonLabels = ["Salir sin guardar", "Seguir creando"];
      } else if (isEditing) {
        title = "Cancelar edición de efecto";
        message =
          "Estás por salir sin guardar los cambios. Si volvés ahora, toda la información que editaste se perderá y no podrá recuperarse. ¿Deseás continuar?";
        buttonLabels = ["Salir sin guardar", "Seguir editando"];
      } else {
        title = "Cancelar operación";
        message =
          "Estás por salir sin guardar los cambios. Si volvés ahora, toda la información se perderá y no podrá recuperarse. ¿Deseás continuar?";
        buttonLabels = ["Salir sin guardar", "Seguir trabajando"];
      }

      effectModalData.value = {
        title: title,
        message: message,
        modalType: "warning",
        showSecondaryButton: true,
        buttonLabels: buttonLabels,
        onConfirm: () => {
          if (isCreating) {
            effectStore.resetForm();
            effectStore.startView();
          } else {
            effectStore.selectFirst();
            effectStore.startView();
          }
          removeTheBlockNavigationToAnotherTab();
          effectModalRef.value.close();

          if (tabToRedirect.value !== null && tabToRedirect.value !== undefined) {
            tabIndex.value = tabToRedirect.value.id;
          }
        },
        onCancel: () => {
          effectModalRef.value.close();
        },
      };
      effectModalRef.value.open();
    };

    const saveEffectButtonAction = async () => {
      try {
        await effectStore.handlePutEfectos();
        removeTheBlockNavigationToAnotherTab();
      } catch (error) {
        console.error("Error al guardar efecto:", error);
      }
    };

    effectStore.setShowSuccessModal(showSuccessModal);

    /**
     * Lógica de Afectados, (mostrar botones correspondientes y emitir acciones hacia el store)
     */
    const affectedStore = useAffectedStore();
    const affectedModalRef = ref(null);
    const actionToDoAffected = ref(null);

    const affectedModalData = ref({
      title: "",
      message: "",
      modalType: "",
      showSecondaryButton: true,
      buttonLabels: [],
      onConfirm: () => {},
      onCancel: () => {},
    });

    const showAffectedModal = (config) => {
      affectedModalData.value = {
        title: config.title,
        message: config.message || "",
        modalType: config.modalType ?? "info",
        showSecondaryButton: config.showSecondaryButton ?? true,
        buttonLabels: config.buttonLabels ?? ["Aceptar", "Cancelar"],
        onConfirm: config.onConfirm ?? (() => {}),
        onCancel: config.onCancel ?? (() => affectedModalRef.value.close()),
      };

      affectedModalRef.value.open();
    };

    const showSuccessModalAffected = () => {
      showAffectedModal({
        title: "¡Los datos se guardaron con éxito!",
        modalType: "success",
        showSecondaryButton: false,
        onConfirm: () => {
          affectedStore.selectFirst();
          affectedStore.startView();
          affectedModalRef.value.close();
        },
      });
    };

    const showDeleteAffected = () => {
      showAffectedModal({
        title: "Eliminar Afectado",
        message: "¿Está seguro de eliminar este afectado? Esta acción no se puede deshacer.",
        modalType: "delete",
        buttonLabels: ["Eliminar", "Cancelar"],

        onConfirm: async () => {
          affectedModalData.value.buttonLabels[0] = "Eliminando...";
          try {
            affectedStore.isLoading = true;
            await affectedStore.handleDeleteAffected();
            affectedModalRef.value.close();
            showDeleteSuccessModalAffected();
          } catch (err) {
            affectedModalRef.value.close();
            showDeleteErrorModalAffected(err.message);
          } finally {
            affectedStore.isLoading = false;
            affectedModalData.value.buttonLabels[0] = "Aceptar";
          }
        },

        onCancel: () => affectedModalRef.value.close(),
      });
    };

    const showDeleteSuccessModalAffected = () => {
      showAffectedModal({
        title: "Afectado eliminado",
        message: "El afectado fue eliminado correctamente.",
        modalType: "success",
        showSecondaryButton: false,
        onConfirm: () => {
          affectedStore.selectFirst();
          affectedStore.startView();
          affectedModalRef.value.close();
        },
      });
    };

    const showDeleteErrorModalAffected = () => {
      showAffectedModal({
        title: "Error al eliminar afectado",
        message: "No se pudo eliminar el afectado. Intente nuevamente.",
        modalType: "warning",
        showSecondaryButton: false,
        onConfirm: () => affectedModalRef.value.close(),
      });
    };

    const showCancelModalAffected = () => {
      actionToDoAffected.value = "cancel";
      affectedModalData.value = {
        title: "Cancelar carga de datos",
        message:
          "Si cancelas ahora, la información ingresada se perderá y no podrá recuperarse. ¿Deseas continuar con la cancelación?",
        modalType: "warning",
        showSecondaryButton: true,
        onConfirm: () => {
          removeTheBlockNavigationToAnotherTab();
          affectedStore.selectFirst();
          affectedStore.startView();
          affectedModalRef.value?.close();
          const actuacionPersonaFisicaIDOriginal = Object.values({
            ...affectedForm.value.selectedPersona.ActuacionPersonaFisicaID,
          }).join("");
          affectedForm.value.selectedPersona.ActuacionPersonaFisicaID =
            actuacionPersonaFisicaIDOriginal + Math.floor(Math.random() * 10000);
        },
        onCancel: () => {
          affectedModalRef.value?.close();
        },
      };

      if (affectedModalRef.value?.open) {
        affectedModalRef.value.open();
      } else {
        console.warn("affectedModalRef no está disponible todavía");
      }
    };

    const cancelAffectedButtonAction = (tabToRedirectFromListener) => {
      if (tabToRedirectFromListener === undefined) {
        tabToRedirect.value = null;
      } else {
        tabToRedirect.value = tabsMap.value.find((u) => u.name === tabToRedirectFromListener);
      }

      actionToDoAffected.value = "cancel";

      const isCreating = affectedStore.isCreate;
      const isEditing = affectedStore.isEdit;

      let title, message, buttonLabels;

      if (isCreating) {
        title = "Cancelar creación de afectado";
        message =
          "Estás por salir sin guardar el nuevo afectado. Si volvés ahora, toda la información que ingresaste se perderá y no podrá recuperarse. ¿Deseás continuar?";
        buttonLabels = ["Salir sin guardar", "Seguir creando"];
      } else if (isEditing) {
        title = "Cancelar edición de afectado";
        message =
          "Estás por salir sin guardar los cambios. Si volvés ahora, toda la información que editaste se perderá y no podrá recuperarse. ¿Deseás continuar?";
        buttonLabels = ["Salir sin guardar", "Seguir editando"];
      } else {
        title = "Cancelar operación";
        message =
          "Estás por salir sin guardar los cambios. Si volvés ahora, toda la información se perderá y no podrá recuperarse. ¿Deseás continuar?";
        buttonLabels = ["Salir sin guardar", "Seguir trabajando"];
      }

      showAffectedModal({
        title,
        message,
        modalType: "warning",
        showSecondaryButton: true,
        buttonLabels,
        onConfirm: () => {
          if (isCreating) {
            affectedStore.resetForm();
            affectedStore.startView();
          } else {
            affectedStore.selectFirst();
            affectedStore.startView();
          }

          removeTheBlockNavigationToAnotherTab();
          affectedModalRef.value.close();

          if (tabToRedirect.value != null) {
            tabIndex.value = tabToRedirect.value.id;
          }
        },
        onCancel: () => affectedModalRef.value.close(),
      });
    };

    const saveAffectedButtonAction = async () => {
      try {
        await affectedStore.handlePutAffecteds();
        removeTheBlockNavigationToAnotherTab();
      } catch (error) {
        console.error("Error al guardar afectado:", error);
      }
    };

    affectedStore.setShowSuccessModal(showSuccessModalAffected);

    /**
     * Lógica de Datos Legales, (mostrar botones correspondientes y emitir acciones hacia el store)
     */
    const legalDataModalRef = ref(null);
    const actionToDoLegalData = ref(null);

    const legalDataModalData = ref({
      title: "",
      message: "",
      modalType: "",
      showSecondaryButton: true,
      buttonLabels: [],
      onConfirm: () => {},
      onCancel: () => {},
    });

    const showCancelModalLegalData = () => {
      actionToDoLegalData.value = "cancel";
      legalDataModalData.value = {
        title: "Cancelar edición de datos legales",
        message:
          "Si cancelas ahora, los cambios realizados se perderán y no podrán recuperarse. ¿Deseas continuar con la cancelación?",
        modalType: "warning",
        showSecondaryButton: true,
        buttonLabels: ["Cancelar edición", "Seguir editando"],
        onConfirm: async () => {
          const actuacionId = sumario.value?.IdActuacion || sumario.value?.id;
          await legalDataStore.cancelEdit(actuacionId);
          legalDataModalRef.value?.close();
          removeTheBlockNavigationToAnotherTab();
        },
        onCancel: () => {
          legalDataModalRef.value?.close();
        },
      };

      if (legalDataModalRef.value?.open) {
        legalDataModalRef.value.open();
      } else {
        console.warn("legalDataModalRef no está disponible todavía");
      }
    };

    const showSuccessModalLegalData = () => {
      actionToDoLegalData.value = "save";
      legalDataModalData.value = {
        title: "¡Los datos se guardaron con éxito!",
        message:
          "La información se ha guardado correctamente. Para regresar a la vista anterior, haga click en 'Continuar'.",
        modalType: "success",
        showSecondaryButton: false,
        buttonLabels: ["Continuar"],
        onConfirm: () => {
          legalDataModalRef.value.close();
        },
        onCancel: () => {},
      };
      legalDataModalRef.value.open();
    };

    const cancelLegalDataButtonAction = (tabToRedirectFromListener) => {
      if (tabToRedirectFromListener === undefined) {
        tabToRedirect.value = null;
      } else {
        tabToRedirect.value = tabsMap.value.find((u) => u.name === tabToRedirectFromListener);
      }

      actionToDoLegalData.value = "cancel";

      const isEditing = legalDataStore.isEdit;

      let title, message, buttonLabels;

      if (isEditing) {
        title = "Cancelar carga de datos";
        message =
          "Si cancelas ahora, la información ingresada se perderá y no podrá recuperarse. ¿Deseas continuar con la cancelación?";
        buttonLabels = ["Aceptar", "Cancelar"];
      } else {
        title = "Cancelar operación";
        message =
          "Estás por salir sin guardar los cambios. Si volvés ahora, toda la información se perderá y no podrá recuperarse. ¿Deseás continuar?";
        buttonLabels = ["Salir sin guardar", "Seguir trabajando"];
      }

      legalDataModalData.value = {
        title: title,
        message: message,
        modalType: "warning",
        showSecondaryButton: true,
        buttonLabels: buttonLabels,
        onConfirm: async () => {
          const actuacionId = sumario.value?.IdActuacion || sumario.value?.id;
          await legalDataStore.cancelEdit(actuacionId);
          removeTheBlockNavigationToAnotherTab();
          legalDataModalRef.value.close();

          if (tabToRedirect.value !== null && tabToRedirect.value !== undefined) {
            tabIndex.value = tabToRedirect.value.id;
          }
        },
        onCancel: () => {
          legalDataModalRef.value.close();
        },
      };
      legalDataModalRef.value.open();
    };

    const saveLegalDataButtonAction = async () => {
      try {
        const actuacionId = sumario.value?.IdActuacion || sumario.value?.id;

        await legalDataStore.saveDatosLegales(actuacionId);
        legalDataStore.startView();

        showSuccessModalLegalData();
        removeTheBlockNavigationToAnotherTab();
      } catch (error) {
        console.error("Error al guardar datos legales:", error);
      }
    };

    /**
     * Lógica de Vinculados, (mostrar botones correspondientes y emitir acciones hacia el store)
     */
    const vinculatedStore = useVinculatedStore();
    const vinculatedModalRef = ref(null);
    const actionToDoVinculated = ref(null);

    const vinculatedModalData = ref({
      title: "",
      message: "",
      modalType: "",
      showSecondaryButton: true,
      buttonLabels: [],
      onConfirm: () => {},
      onCancel: () => {},
    });

    const showVinculatedModal = (config) => {
      vinculatedModalData.value = {
        title: config.title,
        message: config.message || "",
        modalType: config.modalType ?? "info",
        showSecondaryButton: config.showSecondaryButton ?? true,
        buttonLabels: config.buttonLabels ?? ["Aceptar", "Cancelar"],
        onConfirm: config.onConfirm ?? (() => {}),
        onCancel: config.onCancel ?? (() => vinculatedModalRef.value.close()),
      };

      vinculatedModalRef.value.open();
    };

    const showSuccessModalVinculated = () => {
      showVinculatedModal({
        title: "¡Los datos se guardaron con éxito!",
        modalType: "success",
        showSecondaryButton: false,
        onConfirm: () => {
          vinculatedStore.selectFirst();
          vinculatedStore.startView();
          vinculatedModalRef.value.close();
        },
      });
    };

    const showDeleteVinculated = () => {
      showVinculatedModal({
        title: "Eliminar Vinculado",
        message: "¿Está seguro de eliminar este vinculado? Esta acción no se puede deshacer.",
        modalType: "delete",
        buttonLabels: ["Eliminar", "Cancelar"],

        onConfirm: async () => {
          vinculatedModalData.value.buttonLabels[0] = "Eliminando...";
          try {
            vinculatedStore.isLoading = true;
            await vinculatedStore.handleDeleteVinculated();
            vinculatedModalRef.value.close();
            showDeleteSuccessModalVinculated();
          } catch (err) {
            vinculatedModalRef.value.close();
            showDeleteErrorModalVinculated(err.message);
          } finally {
            vinculatedStore.isLoading = false;
            vinculatedModalData.value.buttonLabels[0] = "Aceptar";
          }
        },

        onCancel: () => vinculatedModalRef.value.close(),
      });
    };

    const showDeleteSuccessModalVinculated = () => {
      showVinculatedModal({
        title: "Vinculado eliminado",
        message: "El vinculado fue eliminado correctamente.",
        modalType: "success",
        showSecondaryButton: false,
        onConfirm: () => {
          vinculatedStore.selectFirst();
          vinculatedStore.startView();
          vinculatedModalRef.value.close();
        },
      });
    };

    const showDeleteErrorModalVinculated = () => {
      showVinculatedModal({
        title: "Error al eliminar vinculado",
        message: "No se pudo eliminar el vinculado. Intente nuevamente.",
        modalType: "warning",
        showSecondaryButton: false,
        onConfirm: () => vinculatedModalRef.value.close(),
      });
    };

    const showCancelModalVinculated = () => {
      actionToDoVinculated.value = "cancel";
      vinculatedModalData.value = {
        title: "Cancelar carga de datos",
        message:
          "Si cancelas ahora, la información ingresada se perderá y no podrá recuperarse. ¿Deseas continuar con la cancelación?",
        modalType: "warning",
        showSecondaryButton: true,
        onConfirm: () => {
          removeTheBlockNavigationToAnotherTab();
          vinculatedStore.selectFirst();
          vinculatedStore.startView();
          vinculatedModalRef.value?.close();
          const actuacionPersonaFisicaIDOriginal = Object.values({
            ...vinculatedsFormTab.value.selectedPersona.ActuacionPersonaFisicaID,
          }).join("");
          vinculatedsFormTab.value.selectedPersona.ActuacionPersonaFisicaID =
            actuacionPersonaFisicaIDOriginal + Math.floor(Math.random() * 10000);
        },
        onCancel: () => {
          vinculatedModalRef.value?.close();
        },
      };

      if (vinculatedModalRef.value?.open) {
        vinculatedModalRef.value.open();
      } else {
        console.warn("vinculatedModalRef no está disponible todavía");
      }
    };

    const showErrorModalVinculated = (message) => {
      vinculatedModalData.value = {
        title: "Error al guardar vinculado",
        message,
        modalType: "error",
        showSecondaryButton: false,
        buttonLabels: ["Aceptar"],
        onConfirm: () => {
          vinculatedModalRef.value.close();
        },
        onCancel: () => {
          vinculatedModalRef.value.close();
        },
      };
      vinculatedModalRef.value.open();
    };

    const cancelVinculatedButtonAction = (tabToRedirectFromListener) => {
      if (tabToRedirectFromListener === undefined) {
        tabToRedirect.value = null;
      } else {
        tabToRedirect.value = tabsMap.value.find((u) => u.name === tabToRedirectFromListener);
      }

      actionToDoVinculated.value = "cancel";

      const isCreating = vinculatedStore.isCreate;
      const isEditing = vinculatedStore.isEdit;

      let title, message, buttonLabels;

      if (isCreating) {
        title = "Cancelar creación de vinculado";
        message =
          "Estás por salir sin guardar el nuevo vinculado. Si volvés ahora, toda la información que ingresaste se perderá y no podrá recuperarse. ¿Deseás continuar?";
        buttonLabels = ["Salir sin guardar", "Seguir creando"];
      } else if (isEditing) {
        title = "Cancelar edición de vinculado";
        message =
          "Estás por salir sin guardar los cambios. Si volvés ahora, toda la información que editaste se perderá y no podrá recuperarse. ¿Deseás continuar?";
        buttonLabels = ["Salir sin guardar", "Seguir editando"];
      } else {
        title = "Cancelar operación";
        message =
          "Estás por salir sin guardar los cambios. Si volvés ahora, toda la información se perderá y no podrá recuperarse. ¿Deseás continuar?";
        buttonLabels = ["Salir sin guardar", "Seguir trabajando"];
      }

      showVinculatedModal({
        title,
        message,
        modalType: "warning",
        showSecondaryButton: true,
        buttonLabels,
        onConfirm: () => {
          if (isCreating) {
            vinculatedStore.resetForm();
            vinculatedStore.startView();
          } else {
            vinculatedStore.selectFirst();
            vinculatedStore.startView();
          }

          removeTheBlockNavigationToAnotherTab();
          vinculatedModalRef.value.close();

          if (tabToRedirect.value != null) {
            tabIndex.value = tabToRedirect.value.id;
          }
        },
        onCancel: () => vinculatedModalRef.value.close(),
      });
    };

    const saveVinculatedButtonAction = async () => {
      try {
        await vinculatedStore.handlePutVinculateds();
        removeTheBlockNavigationToAnotherTab();
      } catch (error) {
        const backendMsg =
          error?.data && typeof error.data.error === "string" && error.data.error.trim() !== ""
            ? error.data.error
            : "Ocurrió un error al guardar el vinculado.";

        showErrorModalVinculated(backendMsg);
        console.error("Error al guardar vinculado:", error);
      }
    };

    vinculatedStore.setShowSuccessModal(showSuccessModalVinculated);

    /* 
      Lógica de Personal Interviniente, (mostrar botones correspondientes y emitir acciones hacia el store)
    */
    const intervinienteStore = usePersonalIntervinienteStore();
    const intervinienteModalRef = ref(null);
    const actionToDoInterviniente = ref(null);

    const intervinienteModalData = ref({
      title: "",
      message: "",
      modalType: "",
      showSecondaryButton: true,
      buttonLabels: [],
      onConfirm: () => {},
      onCancel: () => {},
    });

    const showIntervinienteModal = (config) => {
      intervinienteModalData.value = {
        title: config.title,
        message: config.message || "",
        modalType: config.modalType ?? "info",
        showSecondaryButton: config.showSecondaryButton ?? true,
        buttonLabels: config.buttonLabels ?? ["Aceptar", "Cancelar"],
        onConfirm: config.onConfirm ?? (() => {}),
        onCancel: config.onCancel ?? (() => intervinienteModalRef.value.close()),
      };

      intervinienteModalRef.value.open();
    };

    const showSuccessModalInterviniente = () => {
      showIntervinienteModal({
        title: "¡Los datos se guardaron con éxito!",
        modalType: "success",
        showSecondaryButton: false,
        onConfirm: () => {
          intervinienteStore.selectFirst();
          intervinienteStore.startView();
          intervinienteModalRef.value.close();
        },
      });
    };

    const showDeleteInterviniente = () => {
      showIntervinienteModal({
        title: "Eliminar Interviniente",
        message: "¿Está seguro de eliminar este interviniente? Esta acción no se puede deshacer.",
        modalType: "delete",
        buttonLabels: ["Eliminar", "Cancelar"],

        onConfirm: async () => {
          intervinienteModalData.value.buttonLabels[0] = "Eliminando...";
          try {
            intervinienteStore.isLoading = true;
            await intervinienteStore.handleDeleteInterviniente();
            intervinienteModalRef.value.close();
            showDeleteSuccessModalInterviniente();
          } catch (err) {
            intervinienteModalRef.value.close();
            showDeleteErrorModalInterviniente(err.message);
          } finally {
            intervinienteStore.isLoading = false;
            intervinienteModalData.value.buttonLabels[0] = "Aceptar";
          }
        },

        onCancel: () => intervinienteModalRef.value.close(),
      });
    };

    const showDeleteSuccessModalInterviniente = () => {
      showIntervinienteModal({
        title: "Interviniente eliminado",
        message: "El interviniente fue eliminado correctamente.",
        modalType: "success",
        showSecondaryButton: false,
        onConfirm: () => {
          intervinienteStore.selectFirst();
          intervinienteStore.startView();
          intervinienteModalRef.value.close();
        },
      });
    };

    const showDeleteErrorModalInterviniente = (message) => {
      showIntervinienteModal({
        title: "Error al eliminar interviniente",
        message: message || "No se pudo eliminar el interviniente. Intente nuevamente.",
        modalType: "warning",
        showSecondaryButton: false,
        onConfirm: () => intervinienteModalRef.value.close(),
      });
    };

    const showCancelModalInterviniente = () => {
      actionToDoInterviniente.value = "cancel";
      intervinienteModalData.value = {
        title: "Cancelar carga de datos",
        message:
          "Si cancelas ahora, la información ingresada se perderá y no podrá recuperarse. ¿Deseas continuar con la cancelación?",
        modalType: "warning",
        showSecondaryButton: true,
        onConfirm: () => {
          intervinienteStore.selectFirst();
          intervinienteStore.startView();
          intervinienteModalRef.value.close();
        },
        onCancel: () => {
          intervinienteModalRef.value.close();
        },
      };

      intervinienteModalRef.value.open();
    };

    const showErrorModalInterviniente = (message) => {
      intervinienteModalData.value = {
        title: "Error al guardar interviniente",
        message,
        modalType: "error",
        showSecondaryButton: false,
        buttonLabels: ["Aceptar"],
        onConfirm: () => {
          intervinienteModalRef.value.close();
        },
        onCancel: () => {
          intervinienteModalRef.value.close();
        },
      };
      intervinienteModalRef.value.open();
    };

    const cancelIntervinienteButtonAction = (tabToRedirectFromListener) => {
      if (tabToRedirectFromListener === undefined) {
        tabToRedirect.value = null;
      } else {
        tabToRedirect.value = tabsMap.value.find((u) => u.name === tabToRedirectFromListener);
      }

      actionToDoInterviniente.value = "cancel";

      const isCreating = intervinienteStore.isCreate;
      const isEditing = intervinienteStore.isEdit;

      let title, message, buttonLabels;

      if (isCreating) {
        title = "Cancelar creación de interviniente";
        message =
          "Estás por salir sin guardar el nuevo interviniente. Si volvés ahora, toda la información que ingresaste se perderá y no podrá recuperarse. ¿Deseás continuar?";
        buttonLabels = ["Salir sin guardar", "Seguir creando"];
      } else if (isEditing) {
        title = "Cancelar edición de interviniente";
        message =
          "Estás por salir sin guardar los cambios. Si volvés ahora, toda la información que editaste se perderá y no podrá recuperarse. ¿Deseás continuar?";
        buttonLabels = ["Salir sin guardar", "Seguir editando"];
      } else {
        title = "Cancelar operación";
        message =
          "Estás por salir sin guardar los cambios. Si volvés ahora, toda la información se perderá y no podrá recuperarse. ¿Deseás continuar?";
        buttonLabels = ["Salir sin guardar", "Seguir trabajando"];
      }

      showIntervinienteModal({
        title,
        message,
        modalType: "warning",
        showSecondaryButton: true,
        buttonLabels,
        onConfirm: () => {
          if (isCreating) {
            intervinienteStore.resetForm();
            intervinienteStore.startView();
          } else {
            intervinienteStore.selectFirst();
            intervinienteStore.startView();
          }

          removeTheBlockNavigationToAnotherTab();
          intervinienteModalRef.value.close();

          if (tabToRedirect.value != null) {
            tabIndex.value = tabToRedirect.value.id;
          }
        },
        onCancel: () => intervinienteModalRef.value.close(),
      });
    };

    const saveIntervinienteButtonAction = async () => {
      try {
        await intervinienteStore.handlePutIntervinientes();
        removeTheBlockNavigationToAnotherTab();
      } catch (error) {
        const backendMsg =
          error?.data && typeof error.data.error === "string" && error.data.error.trim() !== ""
            ? error.data.error
            : "Ocurrió un error al guardar el interviniente.";

        showErrorModalInterviniente(backendMsg);
        console.error("Error al guardar interviniente:", error);
      }
    };

    intervinienteStore.setShowSuccessModal(showSuccessModalInterviniente);

    /*
      Lógica de canLeave
    */
    const ModalRefLeave = ref(null);
    const pendingRoute = ref(null);
    const forceLeave = ref(false);
    const isLeaveModalOpen = ref(false);

    const openLeaveModal = () => {
      isLeaveModalOpen.value = true;
      openModalTemplate(ModalRefLeave);
    };

    const confirmLeave = () => {
      isLeaveModalOpen.value = false;
      closeModalTemplate(ModalRefLeave);

      if (pendingRoute.value) {
        forceLeave.value = true;
        const route = pendingRoute.value;
        pendingRoute.value = null;

        router.push(route);
      }
    };

    const cancelLeave = () => {
      closeModalTemplate(ModalRefLeave);
    };

    const canLeave = computed(() => {
      return (
        legalDataStore.isEdit ||
        legalDataStore.isCreate ||
        affectedStore.isEdit ||
        affectedStore.isCreate ||
        vinculatedStore.isEdit ||
        vinculatedStore.isCreate ||
        effectStore.isEdit ||
        effectStore.isCreate ||
        editMode.value
      );
    });

    return {
      // Refs
      effectModalRef,
      affectedForm,
      affectedModalRef,
      legalDataModalRef,
      effectModalData,
      affectedModalData,
      legalDataModalData,
      actionToDo,
      actionToDoAffected,
      actionToDoLegalData,
      vinculatedsFormTab,
      vinculatedModalRef,
      intervinienteModalRef,
      effectModalData,
      vinculatedModalData,
      intervinienteModalData,
      actionToDo,
      actionToDoVinculated,
      actionToDoInterviniente,
      FechaUbiRef,
      FileUpload,
      modalUpdateRef,
      ModalRefEsclarecido,
      ModalRefConfirm,
      ModalRefInform,
      ModalRefSwitchActuacion,
      msjEnable,
      mensaje,
      buttomAceptar,
      buttomCancelar,
      iconModal,
      aceptarLabel,
      cancelarLabel,
      ClickAceptar,
      prosecutorUserTypes,
      filesAndDiligences,
      loading,
      orderBy,
      err,
      formType,
      actuacionType,
      modalRefMessage,
      modalUpdateRef,
      ModalRefConfirm,
      ModalRefDelete,
      isDisabled,
      actuacionIDforChange,
      isConfirmDisabled,
      files,
      disabledModifyStatusActuation,
      sumarioEstado,
      tabIndex,
      ModalRefShare,
      errorDescripcion,
      dependenciaForShare,
      isShared,
      indexEmailButtonDisabled,
      editMode,
      modalDateChangesSaved,
      ModalConfirmDeleteActuacion,
      datesAndLocationsStore,
      saveLoading,
      viewMode,
      modalDateChangesWithoutSave,
      legalDataTab,
      tabToRedirect,
      loadingShare,
      buttonDateDisable,
      ModalRefLeave,
      pendingRoute,
      forceLeave,
      isLeaveModalOpen,
      customModalRef,
      modalFinalizacionErrorRef,
      msjFinalizacionEnable,
      mensajeFinalizacion,
      modalTypeFinalizacion,
      modalTitleFinalizacion,
      ClickAceptarFinalizacion,

      // Computeds
      resumen,
      sumario,
      user,
      headerTitle,
      orderList,
      filteredOptions,
      filteredDependencia,
      usersAllowedToEdit,
      mostrarPersonalInterviniente,
      dataDependencia,
      ModalRefSendDependency,
      translateNameFromFormType,
      isForensicOrCriminology,
      datosCargados,
      dependenciasFiltradas,
      ModalShareConfirm,
      mostrarAfectacionPatrimonial,
      renderAfectation,
      isLoadingData,
      tabsMap,
      currentActuation,
      denunciante,
      canLeave,

      // Reactive states
      DescripcionFinalizacion,
      isEsclarecido,
      evidence,
      evidenciasTabKey,
      effectStore,
      affectedStore,
      legalDataStore,
      vinculatedStore,
      evidenciaStore,
      intervinienteStore,

      // Methods
      onTabChange,
      activarProrroga,
      changeStatusActuacion,
      handleFinalizarActuacion,
      seeDiligencia,
      editDiligencia,
      confirmDelete,
      deleteConfirmed,
      cancelDelete,
      goToAgregarDiligencia,
      updateOrderTableDataBase,
      myUploader,
      updateFiles,
      formatNameUFI,
      RemoveFiles,
      btnEnvio,
      openModalTemplate,
      getItems,
      saveActuationInCache,
      isOnlineActuacion,
      authorizedUserActuacion,
      onRowReorder,
      filterDependencia,
      onSave,
      apellidoNombre,
      determineActionButtonsVisibility,
      determineEmailButtonVisibility,
      authorizedUserDiligencia,
      verifyAmountOfDiligences,
      openModalEsclarecido,
      closeModalTemplate,
      deleteGenericDataFromCached,
      fechaCreacion,
      viewFile,
      switchActuacion,
      handleShareActuacion,
      cancelDateButtonAction,
      saveDateButtonAction,
      showEliminarEfecto,
      showDeleteAffected,
      showCancelModal,
      showCancelModalAffected,
      showCancelModalLegalData,
      showCancelModalVinculated,
      showCancelModalInterviniente,
      showSuccessModal,
      showSuccessModalAffected,
      cancelEffectButtonAction,
      cancelAffectedButtonAction,
      cancelLegalDataButtonAction,
      saveEffectButtonAction,
      saveAffectedButtonAction,
      saveLegalDataButtonAction,
      saveVinculatedButtonAction,
      saveIntervinienteButtonAction,
      cancelContinueButtonAction,
      closeErrorModal,
      removeTheBlockNavigationToAnotherTab,
      defineStateColor,
      blockNavigationToAnotherTab,
      callPutEndpoint,
      determineVisibility,
      showDeleteVinculated,
      showDeleteInterviniente,
      openLeaveModal,
      confirmLeave,
      cancelLeave,
      finalizarCambioEstado,
      closeModalFinalizacion,
      mostrarErrorFinalizacion,
    };
  },
  beforeRouteLeave(to, from, next) {
    if (this.forceLeave) {
      this.forceLeave = false;
      next();
      return;
    }

    if (this.canLeave) {
      this.pendingRoute = to;
      this.openLeaveModal();
      next(false);
    } else {
      next();
    }
  },
});
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:ital,wght@0,100..700;1,100..700&family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap");

.mainCard {
  box-shadow: 0px 4px 4px 0px #00000040;
  border-radius: 16px;
}
::v-deep(.p-input-icon-right > i) {
  top: 65%;
  margin-right: 10px;
  padding-top: 5px;
}

.field {
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
}

.confirmation-content {
  padding: 10px;
  gap: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
}

ul {
  margin: 0 0 10px;
  list-style: none;
  padding: 0;
}

ul li {
  list-style: none;
  margin: 0 0 5px;
  padding: auto 0;
}

.detalleSumario h4 {
  margin: 0 0 5px;
}

.detalleSumario p {
  margin: 0 0 10px;
}

.file-title {
  margin-top: 40px;
  margin-bottom: 20px;
}

.negative-mt {
  margin-top: -15px;
}

.input-order {
  min-width: 250px;
  margin-top: -17px;
}

.articulo__nombre {
  width: 82%;
}

.listaArticulos {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  line-height: 0.9;
  font-size: smaller;
}

.containerArticulos {
  border: 1px solid #0b5195;
  border-radius: 6px;
  padding: 5px;
  color: #9ca3af;
}

.btn {
  width: 18%;
}

::v-deep(.p-dialog-mask) {
  width: 100% !important;
}

.preloader {
  display: flex;
  justify-content: center;
  padding: 0;
  height: 45px;
  width: 45px;
  margin-bottom: 25px;
}

.preloaderSpinner {
  display: flex;
  justify-content: center;
  padding-top: 15rem;
}
.page {
  padding: 10px 30px;
  background-color: #f8f9fa;
  min-height: calc(100vh - 92px);
}
.content {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.overlay-cargando {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
}

.deleteButton {
  background-color: #d20f39;
  color: white;
  width: fit-content;
  min-height: 43px;
  border: none;
  border-radius: 6px;
}

.deleteButton:hover {
  background-color: #d20f397c;
}

.deleteButtonOutlined {
  background-color: white;
  color: #d20f39;
  width: fit-content;
  min-height: 43px;
  width: 50px;
  border: 1px solid #d20f39;
  border-radius: 6px;
}

.deleteButtonOutlined:hover {
  opacity: 0.7;
  background-color: #d20f39;
  border: 1px solid #d20f39;
  color: white;
}

.button {
  min-width: 130px;
  min-height: 43px;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  border: none;
  border-radius: 6px;
}

.primaryButton {
  color: white;
  background-color: #0b5195;
}

.primaryButton:hover {
  background-color: #1366b0;
}

.secondaryButton {
  background-color: white;
  color: #0b5195;
  border: 1px #0b5195 solid;
}

.secondaryButton:hover {
  background-color: rgba(255, 255, 255, 0.267);
  color: #1366b0;
}

.warningButton {
  background-color: #ffb700;
  color: white;
  border: none;
}

.warningButton:focus {
  border: none;
}

.warningButton:hover {
  opacity: 0.7;
  background-color: #ffb700;
}

.secondaryWarningButton {
  background-color: white;
  border: 1px #ffb700 solid;
  color: #ffb700;
}

.secondaryWarningButton:hover {
  opacity: 0.7;
  background-color: white !important  ;
  color: #ffb700;
  border: 1px #ffb700 solid !important;
}

.tabTitle {
  font-family: "IBM Plex Sans", sans-serif;
  color: black;
  margin: 0;
  font-weight: 500;
  font-style: Medium;
  font-size: 28px;
  line-height: 32px;
  letter-spacing: 0%;
  vertical-align: middle;
}

@media (max-width: 1080px) and (max-height: 720px) {
  .tabTitle {
    font-size: 20px;
  }
}

/* Split Button */
::v-deep .p-splitbutton-defaultbutton {
  background-color: #0b5195 !important;
  border: none;
  border-radius: 6px;
  min-width: 100px;
  min-height: 43px;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
}

::v-deep .p-splitbutton-menubutton {
  border-radius: 0 6px 6px 0;
  background-color: #0b5195 !important;
  border: none;
}

::v-deep .p-splitbutton-menubutton:hover {
  background-color: #1366b0 !important;
}

::v-deep .p-autocomplete .p-autocomplete-dropdown {
  background-color: #0b5195;
  border-color: #0b5195;
  color: #fff;
}

::v-deep .p-autocomplete .p-autocomplete-dropdown:hover {
  opacity: 0.7;
}

/* Inputs / Labels */
.inputContainer {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.labelInput {
  color: #0b5195;
  font-size: 16px;
  font-weight: 400;
}

.input {
  border: 1px solid #0b5195;
  border-radius: 6px;
  width: 100%; /* importante */
  color: #9ca3af;
}

.input:focus {
  border: none !important;
}

/* Tabs links */
::v-deep .p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link {
  color: #3758f9 !important;
  border: none !important;
  outline: none !important;
  border-bottom: 2px solid #2563eb !important;
}

::v-deep .p-tabview .p-tabview-nav li .p-tabview-nav-link:focus {
  box-shadow: none !important;
  outline: none !important;
}

::v-deep .p-tabview .p-tabview-nav li .p-tabview-nav-link {
  border: none !important;
  border-bottom: 2px solid transparent !important;
}

::v-deep .p-tabview .p-tabview-panels {
  padding: 1em 0 !important;
}

.separator {
  display: inline-block;
  width: 88px;
  height: 3px;
  border-radius: 9999px;
  background-color: #ffb700;
}

@media (min-width: 1081px) {
  ::v-deep(.p-tabview .p-tabview-nav) {
    display: flex !important;
    justify-content: center !important;
    background-color: transparent;
  }
}
</style>
